export default {
	data() {
		return {
			SerialAllInfo: {},
		}
	},
	methods: {
		/* 获取产品详细数据信息 */
		getProductDetailData(TypeID) {
			let data = {};
			if (TypeID == 1 || TypeID == 2) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/PAG310&313.png'),
					],
					SerialName: '边缘网关PAG310 & PAG313',
					SerialIntro: '边缘控制器是互联网IT和控制执行OT之间的一个物理接口设备，PAG310和PAG313边缘控制器具有2路以太网、3路或者4路RS485通信接口以及开关量输入输出接口，通过底板总线HEBus扩展输入和输出。采用梯形图或功能块以及G代码等编程语言对边缘控制器的控制程序进行开发，通过MQTT协议实现与云端接口。PAG具有多种与现场已有控制网络接口互联能力。<br/>（1）网关功能：通过MODBUS TCP/UDP协议和EPA协议与现场MODBUS设备透明传输；<br/>（2）从设备管理功能：通过添加从设备和对从设备资源进行配置，将从设备作为主设备的变量进行管理，提升了系统程序开发效率；<br/>（3）程序通信功能：支持了多种以太网通信功能块，可以与RS485通信功能块，支持MODBUS、Profibus、MPI、USS等协议，以及自由通信功能块，可以与各种现场总线设备实现互联。',
					TypeInfo: [{
							TypeName: 'PAG310',
							TypeIntro: 'PAG310是以通信为主的可编程边缘计算网关控制器，支持EPA/Modbus TCP/Modbus UDP/Profibus-DP/扩展等多种通信协议具有多种通信接口，可实现现场多种总线互联通信。<br/>·2路以太网<br/>·4路RS485<br/>·5路DI，其中前四路为高速<br/>·2路DO(晶体管)<br/>·5路IO中断'
						},
						{
							TypeName: 'PAG313',
							TypeIntro: 'PAG313是以通信为主的可编程边缘计算网关控制器，支持EPA/Modbus TCP/Modbus UDP/Profibus-DP/扩展等多种通信协议具有多种通信接口，可实现现场多种总线互联通信。<br/>·2路以太网<br/>·3路RS485<br/>·5路DI，其中前四路为高速<br/>·4路DO(晶体管)，其中前两路为高速输出<br/>·5路IO中断'
						}
					],
					ParaTable: `<table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="2"><a>技术规格</a></td>
				<td><a>PAG310</a></td>
				<td><a>PAG313</a></td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入点数</td>
				<td>5</td>
				<td>5</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入类型</td>
			   <td>双向输入</td>
			   <td>双向输入</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输出点数</td>
				<td>2</td>
				<td>4</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输出类型</td>
			   <td colspan="2">晶体管</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">用户程序存储器</td>
			   <td colspan="2">256K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">电池保持存储器</td>
			   <td colspan="2">2K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数据存储器</td>
			   <td colspan="2">1M字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">非易失存储器</td>
			   <td colspan="2">64K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">定时器总数</td>
			   <td colspan="2">1024</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">计数器总数</td>
			   <td colspan="2">128</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">定时器中断</td>
			   <td colspan="2">8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">外部中断</td>
			   <td colspan="2">8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">实时时钟</td>
			   <td colspan="2">支持</td>
		   </tr>
		   <tr>
			   <td rowspan="4" class="para-table-tag">RS485通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td >4</td>
				<td >2</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td colspan="2">1200bps、2400bps、4800bps、9600bps、19200bps、38400bps、 57600bps、115200bps、500Kbps、1Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td colspan="2">Modbus/Profibus-DP/扩展IO</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">最大IO设备数量</td>
			   <td colspan="2">16</td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">以太网通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td colspan="2">2</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td colspan="2">10/100Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td colspan="2">EPA/Modbus TCP/Modbus UDP</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">尺寸/mm</td>
			   <td colspan="2">112mm×98mm×25mm</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作温度</td>
			   <td colspan="2">-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作湿度</td>
			   <td colspan="2">20%~95%（不结露）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">抗干扰性</td>
			   <td colspan="2">符合电磁兼容3级标准</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作电压</td>
			   <td colspan="2">9~30VDC</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">消耗功率</td>
			   <td colspan="2">小于3W</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：DCCE网络化可编程控制器用户编程手册',
							downloadName:'manual|DCCE网络化可编程控制器用户编程手册.pdf'
						}
					]
				}
			} else if (TypeID == 3 || TypeID == 4 || TypeID == 5) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/MAC1100&1120&1130.png'),
					],
					SerialName: 'MAC系列中型控制器',
					SerialIntro: 'MAC:Master Automatic Controller<br/>这些主控器可以通过底板总线HEBus网络扩展输入和输出模块，实现可编程控制器的模拟量输入、模拟量输出、开关量输入和开关量输出等输入信号和输出信号的配置，点数配置方便灵活。<br/>可编程序开发软件PLC_Config既可以管理主控器，并对其进行程序开发；也可以对扩展IO模块进行管理和配置。',
					TypeInfo: [{
							TypeName: 'MAC1100',
							TypeIntro: '·1路以太网<br/>·2路RS485<br/>·23路DI<br/>·16路DO(晶体管)<br/>·8路IO中断'
						},
						{
							TypeName: 'MAC1110',
							TypeIntro: '·1路以太网<br/>·2路RS485<br/>·16路DI<br/>·16路DO(继电器)<br/>·8路IO中断'
						},
						{
							TypeName: 'MAC1120',
							TypeIntro: '·1路以太网<br/>·2路RS485<br/>·24路DI<br/>·12路DO(继电器)<br/>·8路IO中断'
						}
					],
					ParaTable: `<table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="2"><a>技术规格</a></td>
			   <td><a>MAC1100</a></td>
			   <td><a>MAC1110</a></td>
			   <td><a>MAC1120</a></td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入点数</td>
			   <td>23</td>
			   <td>16</td>
			   <td>24</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入类型</td>
			   <td>双向输入</td>
			   <td>双向输入</td>
			   <td>双向输入</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输出点数</td>
			   <td>16</td>
			   <td>16</td>
			   <td>12</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输出类型</td>
			   <td>晶体管</td>
			   <td>继电器</td>
			   <td>继电器</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">用户程序存储器</td>
			   <td colspan="3">512K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">电池保持存储器</td>
			   <td colspan="3">2K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数据存储器</td>
			   <td colspan="3">1M字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">非易失存储器</td>
			   <td colspan="3">64K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">定时器总数</td>
			   <td colspan="3">1024</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">计数器总数</td>
			   <td colspan="3">128</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">定时器中断</td>
			   <td colspan="3">8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">外部中断</td>
			   <td colspan="3">8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">实时时钟</td>
			   <td colspan="3">支持</td>
		   </tr>
		   <tr>
			   <td rowspan="4" class="para-table-tag">RS485通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td colspan="3">2</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td colspan="3">2400bps、4800bps、9600bps、19200bps、38400bps、57600bps、115200bps、500Kbps、1Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td colspan="3">Modbus/Profibus-DP/扩展IO</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">最大IO设备数量</td>
			   <td colspan="3">16</td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">以太网通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td colspan="3">1</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td colspan="3">10/100Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td colspan="3">EPA/Modbus TCP/Modbus UDP</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">尺寸/mm</td>
			   <td colspan="3">112mm×98mm×45mm</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">重量/g</td>
			   <td>290</td>
			   <td>317</td>
			   <td>300</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作温度</td>
			   <td colspan="3">-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作湿度</td>
			   <td colspan="3">20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">抗干扰性</td>
			   <td colspan="3">符合电磁兼容3级标准</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作电压</td>
			   <td colspan="3">9~30VDC</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">消耗功率</td>
			   <td>＜3W</td>
			   <td>＜8W</td>
			   <td>＜8W</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：MAC系列可编程控制器使用手册.pdf',
							downloadName:'manual|MAC系列可编程控制器使用手册2019.pdf'
						},
						{
							displayName:'文档：DCCE网络化可编程控制器用户编程手册',
							downloadName:'manual|DCCE网络化可编程控制器用户编程手册.pdf'
						}
					]
				}
			} else if (TypeID == 6 || TypeID == 7 || TypeID == 8 || TypeID == 9 || TypeID == 10) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/MAC1132.jpg'),
						require('@/assets/images/edge/products/details/MAC1680_2480-3508.jpg'),
						require('@/assets/images/edge/products/details/MAC1680_2480-3508-black.jpg')
					],
					SerialName: 'MAC系列运动控制器',
					SerialIntro: 'MAC:Master Automatic Controller<br/>MAC系列运动控制器通过高速输入输出脉冲和高速环网与驱动器连接组成数控系统。通过将轴配置成轴组组成数控系统。还可以通过配置机械结构，支持机器人模型，实现机器人控制。<br/>控制器支持PLCopen规范定义的控制功能块，通过梯形图和功能块编程方式进行程序开发。<br/>还支持G代码程序运行功能，通过使用G代码编程方式实现数控加工程序开发。<br/>MAC系列控制器具有以太网和RS485标准接口，支持HEBus底板总线扩充系统输入和输出，真正实现可编程控制（PLC）、运动控制（MC）、数控（CNC）、机器人控制（RCS）、可编程网关（PAG）一体化功能。',
					TypeInfo: [{
							TypeName: 'MAC1132',
							TypeIntro: 'MAC1132是运动主控器的一个型号，该型号为运动控制型主控，全面支持PLC_Open语言标准，让运动控制以指令块的方式来描述，使用简单。<br/>·1路以太网，2路RS485<br/>·23路DI，其中包含8路高速计数，最大1MHz<br/>·16路DO(晶体管),其中包含16路高速脉冲，最大500KHz<br/>·8路IO中断<br/>·支持4个实轴，4个虚轴指令<br/>·支持PLC_Open标准<br/>·支持单轴运动控制指令'
						},
						{
							TypeName: 'MAC1133',
							TypeIntro: '与MAC1132相同，区别是支持8个实轴。·1路以太网，2路RS485<br/>·23路DI，其中包含8路高速计数，最大1MHz<br/>·16路DO(晶体管),其中包含16路高速脉冲，最大500KHz<br/>·8路IO中断<br/>·支持8个实轴，4个虚轴指令<br/>·支持PLC_Open标准，支持MC_PWM占空比可调脉冲输出<br/>·支持单轴运动控制指令'
						},
						{
							TypeName: 'MAC160',
							TypeIntro: 'MAC160为环网运动控制主控器，全面支持PLC_Open语言标准，可通过环网方式与环网伺服器组成环网控制系统，支持G代码编程，可应用于数控系统中。<br/>·2路以太网<br/>·4路RS485<br/>·5路DI，其中前四路为高速<br/>·2路DO(晶体管)<br/>·5路IO中断'
						},
						{
							TypeName: 'MAC1630',
							TypeIntro: '支持运动控制模型，支持G代码<br/>·1路以太网，2路RS485<br/>·23路DI，其中包含8路高速计数，最大1MHz<br/>·16路DO(晶体管),其中包含16路高速脉冲，最大500KHz<br/>·8路IO中断<br/>·支持8个实轴，4个虚轴，4个轴组指令<br/>·支持PLC_Open标准<br/>·支持直线插补、圆弧插补、多轴运动控制等算法<br/>·支持G代码'
						},
						{
							TypeName: 'MAC1680',
							TypeIntro: '在MAC1630的基础上，增加了更多的DI，DO，轴数与轴组指令<br/>·1路以太网，2路RS485<br/>·35路DI，其中包含8路高速计数，最大1MHz<br/>·24路DO(晶体管),其中包含16路高速脉冲，最大500KHz<br/>·8路IO中断<br/>·支持12个实轴，4个虚轴，6个轴组指令<br/>·支持PLC_Open标准<br/>·支持直线插补、圆弧插补、多轴运动控制等算法<br/>·支持G代码编程'
						}
					],
					ParaTable: `<table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="2"><a>技术规格</a></td>
			   <td><a>MAC1132</a></td>
			   <td><a>MAC1133</a></td>
			   <td><a>MAC1630</a></td>
			   <td><a>MAC1680</a></td>
			   <td><a>MAC160</a></td>
			   <td><a>MAC163</a></td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入点数</td>
			   <td colspan="3">15路普通+8路高速</td>
				<td >31路普通+4路高速</td>
				<td colspan="2">1路普通+4路高速</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入类型</td>
			   <td colspan="3">双向输入</td>
				<td >双向输入</td>
			   <td colspan="2">双向输入</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输出点数</td>
			   <td colspan="3">16路高速</td>
			   <td>24路高速</td>
				<td>2路高速</td>
				<td>4路高速</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输出类型</td>
			   <td colspan="3">晶体管</td>
			   <td>晶体管</td>
				<td>晶体管</td>
				<td>晶体管</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">用户程序存储器</td>
			   <td colspan="6">256K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">电池保持存储器</td>
			   <td colspan="6">2K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数据存储器</td>
			   <td colspan="6">1M字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">非易失存储器</td>
			   <td colspan="6">64K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">定时器总数</td>
			   <td colspan="6">1024</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">计数器总数</td>
			   <td colspan="6">128</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">定时器中断</td>
			   <td colspan="6">8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">外部中断</td>
			   <td colspan="6">8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">实时时钟</td>
			   <td colspan="6">支持</td>
		   </tr>
		   <tr>
			   <td rowspan="4" class="para-table-tag">RS485通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td colspan="6">2</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td colspan="6">2400bps、4800bps、9600bps、19200bps、38400bps、57600bps、115200bps、500Kbps、1Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td colspan="6">Modbus/Profibus-DP/扩展IO</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">最大IO设备数量</td>
			   <td colspan="6">16</td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">以太网通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td colspan="4">1</td>
				<td colspan="2">2</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td colspan="6">10/100Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td colspan="6">EPA/Modbus TCP/Modbus UDP</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">尺寸/mm</td>
			   <td colspan="3">112mm×98mm×45mm</td>
				<td >112mm×98mm×70mm</td>
				<td colspan="2">112mm×98mm×25mm</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作温度</td>
			   <td colspan="6">-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作湿度</td>
			   <td colspan="6">20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">抗干扰性</td>
			   <td colspan="6">符合电磁兼容3级标准</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作电压</td>
			   <td colspan="6">9~30VDC</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">消耗功率</td>
			   <td colspan="610:59 2019/12/25">＜3W</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：MAC系列可编程控制器使用手册.pdf',
							downloadName:'manual|MAC系列可编程控制器使用手册2019.pdf'
						},
						{
							displayName:'文档：DCCE网络化可编程控制器用户编程手册',
							downloadName:'manual|DCCE网络化可编程控制器用户编程手册.pdf'
						}
					]
				}
			} else if (TypeID == 11) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/PEC3000.png'),
					],
					SerialName: '分布控制器',
					SerialIntro: '以太网可编程控制器PEC系列(PEC:Programmable Ethernet Controller)。<br/>这些控制器之间可以通过底板总线MB+网络互联，组成分布式控制系统。包括开入开出控制器PEC3000系列，模入模出控制器PEC5000系列，混合型控制器PEC8000系列。<br/>通过可编程序开发软件PLC_Config对网络中的控制器进行统一管理和程序开发。每个控制器既可以独立工作，也可以通过网络协同工作，组成分布式控制系统，有效地提高了控制系统程序运行效率，同时也分散了由于控制器失效导致系统全部瘫痪的风险，提高了系统可靠性。',
					TypeInfo: [{
						TypeName: 'PEC3000',
						TypeIntro: 'PEC3000控制器是一种支持多种通信协议，具有逻辑控制、过程控制、运动控制功能的分布式网络化PLC。支持IEC61131-3标准的梯形图、功能块编程，具有逻辑指令，运算指令，定时/计数指令，控制指令，中断指令，网络通信指令和专用指令等，指令集丰富。支持EPA、Modbus、Profibus-DP、USS等主流控制网络协议，具有多级主从设备扩展和第三方设备互连的能力。以网络系统为整体，对系统中的设备进行统一管理和编程开发，可以实现大中小型可编程控制系统的各种功能。)。<br/>·24路DI，其中4路高速DI<br/>·16路DO，其中2路高速DO<br/>·2路RS485接口<br/>·1路100M以太网接口'
					}],
					ParaTable: `<table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="2"><a>技术规格</a></td>
			   <td><a>PEC2000</a></td>
			   <td><a>PEC3000</a></td>
			   <td><a>PEC3400</a></td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数字量输入</td>
			   <td>20路普通+4路高速</td>
			   <td>20路普通+4路高速</td>
			   <td>8路普通</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数字量输入类型</td>
			   <td>双向输入</td>
			   <td>双向输入</td>
			   <td>双向输入</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数字量输出</td>
			   <td>14路普通+2路高速</td>
			   <td>14路普通+2路高速</td>
			   <td>32路普通</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数字量输出类型</td>
			   <td>NPN或PNP晶体管输出</td>
			   <td>NPN或PNP晶体管输出</td>
			   <td>NPN或PNP晶体管输出</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">用户程序存储器</td>
			   <td colspan="3">48K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">电池保持存储器</td>
			   <td colspan="3">10.5K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数据存储器</td>
			   <td colspan="3">512字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">非易失存储器</td>
			   <td>4K字</td>
			   <td>2K字</td>
			   <td>2K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">定时器总数</td>
			   <td colspan="3">128</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">计数器总数</td>
			   <td colspan="3">128</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">定时器中断</td>
			   <td colspan="3">8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">外部中断</td>
			   <td colspan="3">10</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">实时时钟</td>
			   <td colspan="3">支持</td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">RS485通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td colspan="3">2</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td colspan="3">9600bps-115200bps、500Kbps、1Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td colspan="3">Modbus/MB+/Profibus-DP</td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">以太网通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td colspan="3">1</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td colspan="3">10/100Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td colspan="3">EPA/Modbus TCP/Modbus UDP</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">尺寸/mm</td>
			   <td colspan="3">112mm×98mm×45mm</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">重量/g</td>
			   <td>350</td>
			   <td>350</td>
			   <td>350</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作温度</td>
			   <td colspan="3">-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作湿度</td>
			   <td colspan="3">20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">抗干扰性</td>
			   <td colspan="3">符合电磁兼容3级标准</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作电压</td>
			   <td colspan="3">12~30VDC</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">消耗功率</td>
			   <td>＜5W</td>
			   <td>＜5W</td>
			   <td>＜5W</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">从设备数量</td>
			   <td>16</td>
			   <td>16</td>
			   <td>16</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">从设备AI、AQ/AI、AQ</td>
			   <td colspan="3">16字、16字/256位、256位</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：系列可编程控制器使用手册',
							downloadName:'manual|PEC系列可编程控制器使用手册.pdf'
						},
						{
							displayName:'文档：PEC3000用户使用手册',
							downloadName:'manual|PEC3000用户使用手册.pdf'
						},
						{
							displayName:'文档：PEC3000产品接线图',
							downloadName:'manual|PEC3000.jpg'
						}
					]
				}
			} else if (TypeID == 12) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/PEC5000-aodo.png'),
					],
					SerialName: '分布控制器',
					SerialIntro: '以太网可编程控制器PEC系列(PEC:Programmable Ethernet Controller)。<br/>这些控制器之间可以通过底板总线MB+网络互联，组成分布式控制系统。包括开入开出控制器PEC3000系列，模入模出控制器PEC5000系列，混合型控制器PEC8000系列。<br/>通过可编程序开发软件PLC_Config对网络中的控制器进行统一管理和程序开发。每个控制器既可以独立工作，也可以通过网络协同工作，组成分布式控制系统，有效地提高了控制系统程序运行效率，同时也分散了由于控制器失效导致系统全部瘫痪的风险，提高了系统可靠性。',
					TypeInfo: [{
						TypeName: 'PEC5000',
						TypeIntro: 'PEC5000控制器是一种支持多种通信协议，具有逻辑控制、过程控制功能的分布式网络化PLC。支持IEC61131-3 标准的梯形图、功能块编程，具有逻辑指令，运算指令，定时/计数指令，控制指令，中断指令，网络通信指令和专用指令等，指令集丰富。支持EPA、Modbus、Profibus-DP、USS等主流控制网络协议，具有多级主从设备扩展和第三方设备互连的能力。以网络系统为整体，对系统中的设备进行统一管理和编程开发，可以实现大中小型可编程控制系统的各种功能。<br/>特点：无运动控制功能但拥有更多的资源。分为AO，DO两个版本。<br/>·2路RS485接口<br/>·1路100M以太网<br/>·AO版本：8路AI，8路AO，1路DI，1路DO<br/>·DO版本：8路AI，无AO，1路DI，9路DO'
					}],
					ParaTable: `<table class="para-table"">
		   <tr class="para-table-head">
			   <td colspan="3"><a>技术规格</a></td>
			   <td><a>PEC4000-AO</a></td>
			   <td><a>PEC4000-DO</a></td>
			   <td><a>PEC5000-AO</a></td>
			   <td><a>PEC5000-DO</a></td>
		   </tr>
		   <tr>
			   <td rowspan="2" class="para-table-tag">数字量输入</td>
			   <td colspan="2" class="para-table-tag">输入点数</td>
			   <td>1</td>
			   <td>1</td>
			   <td>1</td>
			   <td>1</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入类型</td>
			   <td colspan="4">双向输入</td>
		   </tr>
		   <tr>
			   <td rowspan="2" class="para-table-tag">数字量输出</td>
			   <td colspan="2" class="para-table-tag">输出点数</td>
			   <td>1</td>
			   <td>9</td>
			   <td>1</td>
			   <td>9</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输出类型</td>
			   <td colspan="4">NPN或PNP晶体管输出</td>
		   </tr>
		   <tr>
			   <td rowspan="8" class="para-table-tag">模拟量输入</td>
			   <td colspan="2" class="para-table-tag">输入数量</td>
			   <td>4</td>
			   <td>4</td>
			   <td>8</td>
			   <td>8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入类型</td>
			   <td colspan="4">热电偶：K、E、S、T、R、N、J、B、W<br />热电阻：Pt100、Cu50、Cu100、Ni120<br />电压：-5V~5V、-10V~10V、0~5V、1~5V、0~50mV<br />电流：0~20mA、4~20mA</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="6">分辨率</td>
			   <td class="para-table-tag" rowspan="2">温度</td>
			   <td colspan="4">Pt100:0.01℃</td>
		   </tr>
		   <tr>
			   <td colspan="4">热电阻、热电偶：0.1℃</td>
		   </tr>
		   <tr>
			   <td rowspan="2" class="para-table-tag">电压</td>
			   <td colspan="4">0~5V：2000码/V</td>
		   </tr>
		   <tr>
			   <td colspan="4">0~50mV：300码/mV</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="2">电流</td>
			   <td colspan="4">0~20mA：500码/mA</td>
		   </tr>
		   <tr>
			   <td colspan="4">4~20mA：500码/mA</td>
		   </tr>
		   <tr>
			   <td rowspan="5" class="para-table-tag">模拟量输出</td>
			   <td colspan="2" class="para-table-tag">输出数量</td>
			   <td>8</td>
			   <td>--</td>
			   <td>8</td>
			   <td>--</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">模拟量输出范围</td>
			   <td colspan="4">0~20V（0~20000码）、0~10V（0~10000码）、<br />0~5V（0~5000码）；0~20mA（0~5000码）、<br />4~20mA（1000~5000码）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">分辨率</td>
			   <td colspan="4">0.1%FS</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">带负载能力</td>
			   <td colspan="4">电压型 &lt;50mA</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">过流保护</td>
			   <td colspan="4">50mA，自恢复型</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">用户程序存储器</td>
			   <td colspan="4">48K字</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">电池保持存储器</td>
			   <td colspan="4">10.5K字</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">数据存储器</td>
			   <td colspan="4">512字</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">非易失存储器</td>
			   <td colspan="4">2K字</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">定时器总数</td>
			   <td colspan="4">128</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">计数器总数</td>
			   <td colspan="4">128</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">定时器中断</td>
			   <td colspan="4">8</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">外部中断</td>
			   <td colspan="4">1</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">实时时钟</td>
			   <td colspan="4">支持</td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">RS485通信</td>
			   <td colspan="2" class="para-table-tag">端口数</td>
			   <td colspan="4">2</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通信速率</td>
			   <td colspan="4">9600bps-115200bps、500Kbps、1Mbps</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通信协议</td>
			   <td colspan="4">Modbus/MB+/Profibus-DP</td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">以太网通信</td>
			   <td colspan="2" class="para-table-tag">端口数</td>
			   <td colspan="4">1</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通信速率</td>
			   <td colspan="4">10/100Mbps</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通信协议</td>
			   <td colspan="4">EPA/Modbus TCP/Modbus UDP</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">尺寸/mm</td>
			   <td colspan="4">110mm×110mm×45mm</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">重量/g</td>
			   <td colspan="4">350</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">工作温度</td>
			   <td colspan="4">-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">工作湿度</td>
			   <td colspan="4">20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">抗干扰性</td>
			   <td colspan="4">符合电磁兼容3级标准</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">工作电压</td>
			   <td colspan="4">12~30VDC</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">消耗功率</td>
			   <td colspan="4">＜5W</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">从设备数量</td>
			   <td>16</td>
			   <td>16</td>
			   <td>16</td>
			   <td>16</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">从设备AI、AQ/DI、DQ</td>
			   <td colspan="4">16字、16字/256位、256位</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：PEC系列可编程控制器使用手册',
							downloadName:'manual|PEC系列可编程控制器使用手册.pdf'
						},
						{
							displayName:'文档：PEC5000用户使用手册',
							downloadName:'manual|PEC5000用户使用手册.pdf'
						},
						{
							displayName:'文档：PEC5000-AO产品接线图',
							downloadName:'manual|PEC5000-AO.jpg'
						},
						{
							displayName:'文档：PEC5000-DO产品接线图',
							downloadName:'manual|PEC5000-DO.jpg'
						}
					]
				}
			} else if (TypeID == 13) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/PEC8000.png'),
					],
					SerialName: '分布控制器',
					SerialIntro: '以太网可编程控制器PEC系列(PEC:Programmable Ethernet Controller)。<br/>这些控制器之间可以通过底板总线MB+网络互联，组成分布式控制系统。包括开入开出控制器PEC3000系列，模入模出控制器PEC5000系列，混合型控制器PEC8000系列。<br/>通过可编程序开发软件PLC_Config对网络中的控制器进行统一管理和程序开发。每个控制器既可以独立工作，也可以通过网络协同工作，组成分布式控制系统，有效地提高了控制系统程序运行效率，同时也分散了由于控制器失效导致系统全部瘫痪的风险，提高了系统可靠性。',
					TypeInfo: [{
						TypeName: 'PEC8000',
						TypeIntro: 'PEC8000控制器是一种支持多种通信协议，具有逻辑控制、过程控制、运动控制功能的分布式网络化PLC。支持IEC61131-3标准的梯形图、功能块编程，具有逻辑指令，运算指令，定时/计数指令，控制指令，中断指令，网络通信指令和专用指令等，指令集丰富。支持EPA、Modbus、USS等主流控制网络协议，具有多级主从设备扩展和第三方设备互连的能力。以网络系统为整体，对系统中的设备进行统一管理和编程开发，可以实现大中小型可编程控制系统的各种功能。<br/>特点：拥有高速端口<br/><br/>·6路AI，2路AQ<br/>·8路DI，8路DO，其中4路高速DI，2路高速DO<br/>·2路RS485接口<br/>·1路100M以太网接口'
					}],
					ParaTable: `<table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="3"><a>技术规格</a></td>
			   <td><a>PEC8000</a></td>
			   <td><a>PMC2000</a></td>
		   </tr>
		   <tr>
			   <td rowspan="2" class="para-table-tag">数字量输入</td>
			   <td colspan="2" class="para-table-tag">输入点数</td>
			   <td colspan="2">4路普通+4路高速（最高输入频率20Khz）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入类型</td>
			   <td colspan="2">双向输入</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="2">数字量输出</td>
			   <td colspan="2" class="para-table-tag">输出点数</td>
			   <td colspan="2">6路普通+2路高速（最高输出频率20Khz）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输出类型</td>
			   <td colspan="2">NPN或PNP晶体管输出</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="8">模拟量输入</td>
			   <td colspan="2" class="para-table-tag">输入数量</td>
			   <td colspan="2">6路普通</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入类型</td>
			   <td colspan="2">热电偶：K、E、S、T、R、N、J、B、W<br />
				   热电阻：Pt100、Cu50、Cu100、Ni120<br />
				   电压：-5V~5V、-10V~10V、0~5V、1~5V、0~50mV<br />
				   电流：0~20mA、4~20mA
				</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="6">分辨率</td>
			   <td class="para-table-tag" rowspan="2">温度</td>
			   <td colspan="2">Pt100:0.01℃</td>
		   </tr>
		   <tr>
			   <td colspan="2">热电阻、热电偶：0.1℃</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="2">电压</td>
			   <td colspan="2">0~5V：2000码/V</td>
		   </tr>
		   <tr>
			   <td colspan="2">0~50mV：300码/mV</td>
		   </tr>
		   <tr>
			   <td rowspan="2" class="para-table-tag">电流</td>
			   <td colspan="2">0~20mA：500码/mA</td>
		   </tr>
		   <tr>
			   <td colspan="2">4~20mA：500码/mA</td>
		   </tr>
		   <tr>
			   <td rowspan="5" class="para-table-tag">模拟量输出</td>
			   <td colspan="2" class="para-table-tag">输出数量</td>
			   <td>2路普通</td>
			   <td>2路普通</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">模拟量输出范围</td>
			   <td colspan="2">0~20V（0~20000码）、0~10V（0~10000码）、<br />
				   0~5V（0~5000码）；0~20mA（0~5000码）、<br />
				   4~20mA（1000~5000码）
				</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">分辨率</td>
			   <td colspan="2">0.1%FS</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">带负载能力</td>
			   <td colspan="2">电压型 &lt;50mA</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">过流保护</td>
			   <td colspan="2">50mA，自恢复型</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">用户程序存储器</td>
			   <td colspan="2">48K字</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">电池保持存储器</td>
			   <td colspan="2">10.5K字</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">数据存储器</td>
			   <td colspan="2">512字</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">非易失存储器</td>
			   <td colspan="2">2字</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">定时器总数</td>
			   <td colspan="2">128</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">计数器总数</td>
			   <td colspan="2">128</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">定时器中断</td>
			   <td colspan="2">8</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">外部中断</td>
			   <td colspan="2">10</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">实时时钟</td>
			   <td colspan="2">支持</td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">RS485通信</td>
			   <td colspan="2" class="para-table-tag">端口数</td>
			   <td colspan="2">2</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通信速率</td>
			   <td colspan="2">9600bps-115200bps、500Kbps、1Mbps</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通信协议</td>
			   <td colspan="2">Modbus/MB+</td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">以太网通信</td>
			   <td colspan="2" class="para-table-tag">端口数</td>
			   <td>1</td>
			   <td>--</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通信速率</td>
			   <td>10/100Mbps</td>
			   <td> -- </td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通信协议</td>
			   <td>EPA/Modbus TCP<br />/Modbus UDP</td>
			   <td>--</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">尺寸/mm</td>
			   <td colspan="2">110mm×110mm×45mm</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">重量/g</td>
			   <td colspan="2">350</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">工作温度</td>
			   <td colspan="2">-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">工作湿度</td>
			   <td colspan="2">20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">抗干扰性</td>
			   <td colspan="2">符合电磁兼容3级标准</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">工作电压</td>
			   <td colspan="2">12~30VDC</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">消耗功率</td>
			   <td colspan="2">＜5W</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">从设备数量</td>
			   <td colspan="2">16</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">从设备AI、AQ/DI、DQ</td>
			   <td colspan="2">16字、16字/256位、256位</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：PEC系列可编程控制器使用手册',
							downloadName:'manual|PEC系列可编程控制器使用手册.pdf'
						},
						{
							displayName:'文档：PEC8000用户使用手册',
							downloadName:'manual|PEC8000用户使用手册.pdf'
						},
						{
							displayName:'文档：PEC8000产品接线图',
							downloadName:'manual|PEC8000.jpg'
						}
					]
				}
			} else if (TypeID == 14) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/AIO5000-aodo.png'),
					],
					SerialName: '分布扩展模块AIO系列',
					SerialIntro: '',
					TypeInfo: [{
						TypeName: 'AIO5000',
						TypeIntro: 'AIO5000是一种支持多种通信协议，具有逻辑控制、过程控制功能的扩展型PLC。功能上与PEC系列无太大差别，也分为AO与DO版。<br/>·2路RS485接口<br/>·AO版本：8路AI，8路AO，1路DI，1路DO<br/>·DO版本：8路AI，无AO，1路DI，9路DO'
					}],
					ParaTable: `<table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="3"><a>技术规格</a></td>
			   <td><a>AIO4000-AO</a></td>
			   <td><a>AIO4000-DO</a></td>
			   <td><a>AIO5000-AO</a></td>
			   <td><a>DIO5000-DO</a></td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="2">数字量输入</td>
			   <td colspan="2" class="para-table-tag">输入点数</td>
			   <td>1</td>
			   <td>1</td>
			   <td>1</td>
			   <td>1</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入类型</td>
			   <td colspan="4">双向输入</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="2">数字量输出</td>
			   <td colspan="2" class="para-table-tag">输出点数</td>
			   <td>1</td>
			   <td>9</td>
			   <td>1</td>
			   <td>9</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输出类型</td>
			   <td colspan="4">NPN或PNP晶体管输出</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="8">模拟量输入</td>
			   <td colspan="2" class="para-table-tag">输入数量</td>
			   <td>4</td>
			   <td>4</td>
			   <td>8</td>
			   <td>8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入类型</td>
			   <td colspan="4">热电偶：K、E、S、T、R、N、J、B、W<br />
				   热电阻：Pt100、Cu50、Cu100、Ni120<br />
				   电压：-5V~5V、-10V~10V、0~5V、1~5V、0~50mV<br />
				   电流：0~20mA、4~20mA</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="6">分辨率</td>
			   <td class="para-table-tag" rowspan="2">温度</td>
			   <td colspan="4">Pt100:0.01℃</td>
		   </tr>
		   <tr>
			   <td colspan="4">热电阻、热电偶：0.1℃</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="2">电压</td>
			   <td colspan="4">0~5V：2000码/V</td>
		   </tr>
		   <tr>
			   <td colspan="4">0~50mV：300码/mV</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="2">电流</td>
			   <td colspan="4">0~20mA：500码/mA</td>
		   </tr>
		   <tr>
			   <td colspan="4">4~20mA：500码/mA</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="5">模拟量输出</td>
			   <td colspan="2" class="para-table-tag">输出数量</td>
			   <td>8</td>
			   <td>--</td>
			   <td>8</td>
			   <td>--</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">模拟量输出范围</td>
			   <td colspan="4">0~20V（0~20000码）、0~10V（0~10000码）、<br />
				   0~5V（0~5000码）；0~20mA（0~5000码）、<br />
				   4~20mA（1000~5000码）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">分辨率</td>
			   <td colspan="4">0.1%FS</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">带负载能力</td>
			   <td colspan="4">电压型 &lt;50mA</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">过流保护</td>
			   <td colspan="4">50mA，自恢复型</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">用户程序存储器</td>
			   <td colspan="4">48K字</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">电池保持存储器</td>
			   <td colspan="4">10.5K字</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">数据存储器</td>
			   <td colspan="4">512字</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">非易失存储器</td>
			   <td colspan="4">2字</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">定时器总数</td>
			   <td colspan="4">128</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">计数器总数</td>
			   <td colspan="4">128</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">定时器中断</td>
			   <td colspan="4">8</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">IO中断</td>
			   <td>1</td>
			   <td>8</td>
			   <td>1</td>
			   <td>8</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">实时时钟</td>
			   <td colspan="4">支持</td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">RS485通信</td>
			   <td colspan="2" class="para-table-tag">端口数</td>
			   <td colspan="4">2</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通信速率</td>
			   <td colspan="4">9600bps-115200bps、500Kbps、1Mbps</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通信协议</td>
			   <td colspan="4">Modbus/MB+/Profibus-DP</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">尺寸/mm</td>
			   <td colspan="4">110mm×110mm×45mm</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">重量/g</td>
			   <td colspan="4">350</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">工作温度</td>
			   <td colspan="4">-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">工作湿度</td>
			   <td colspan="4">20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">抗干扰性</td>
			   <td colspan="4">符合电磁兼容3级标准</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">工作电压</td>
			   <td colspan="4">12~30VDC</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">消耗功率</td>
			   <td colspan="4">＜5W</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">从设备数量</td>
			   <td>16</td>
			   <td>16</td>
			   <td>16</td>
			   <td>16</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">从设备AI、AQ/DI、DQ</td>
			   <td colspan="4">16字、16字/256位、256位</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：AIO5000用户使用手册',
							downloadName:'manual|AIO5000用户使用手册.pdf'
						},
						{
							displayName:'文档：AIO5000-AO产品接线图',
							downloadName:'manual|AIO5000-AO.jpg'
						},
						{
							displayName:'文档：AIO5000-DO产品接线图',
							downloadName:'manual|AIO5000-DO.jpg'
						}
					]
				}
			} else if (TypeID == 15 || TypeID == 16) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/DIO2000&3000.png'),
					],
					SerialName: '分布扩展模块DIO系列',
					SerialIntro: '',
					TypeInfo: [{
							TypeName: 'DIO2000',
							TypeIntro: 'DIO2000是IO扩展模块，不支持编程功能。<br/>·23路普通DI<br/>·12路普通DO<br/>·1路RS485接口'
						},
						{
							TypeName: 'DIO3000',
							TypeIntro: 'DIO3000控制器是一种支持逻辑控制、过程控制、运动控制功能的分布式网络化PLC。支持IEC61131-3标准的梯形图、功能块编程，具有逻辑指令，运算指令，定时/计数指令，控制指令，中断指令，串行指令和专用指令等，指令集丰富。支持EPA、Modbus、Profibus-DP、USS等主流控制网络协议，具有多级主从设备扩展和第三方设备互连的能力。<br/>·2路AQ<br/>·24路DI，其中4路高速DI<br/>·16路DO，其中2路高速DO<br/>·2路RS485接口'
						}
					],
					ParaTable: `<table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="2"><a>技术规格</a></td>
			   <td><a>DIO2000</a></td>
			   <td><a>DIO3000</a></td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数字量输入</td>
			   <td>23路普通</td>
			   <td>20路普通+4路高速</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数字量输入类型</td>
			   <td colspan="2">双向输入</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数字量输出</td>
			   <td>12路普通</td>
			   <td>14路普通+2路高速</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数字量输出类型</td>
			   <td colspan="2">NPN晶体管输出</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">模拟量输出</td>
			   <td>--</td>
			   <td>2路普通</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">用户程序存储器</td>
			   <td>--</td>
			   <td>48K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">电池保持存储器</td>
			   <td>--</td>
			   <td>10.5K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数据存储器</td>
			   <td>--</td>
			   <td>512字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">非易失存储器</td>
			   <td>--</td>
			   <td>2K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">定时器总数</td>
			   <td colspan="2">128</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">计数器总数</td>
			   <td colspan="2">128</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">定时器中断</td>
			   <td colspan="2">8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">IO中断</td>
			   <td colspan="2">8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">实时时钟</td>
			   <td colspan="2">支持</td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">RS485通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td>1</td>
			   <td>2</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td>1200bps-38400bps</td>
			   <td>9600bps-115200bps<br />
				   、500Kbps、1Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td>Modbus RTU</td>
			   <td>Modbus/MB+<br />
				   /Profibus-DP</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">尺寸/mm</td>
			   <td>110mm×110mm×35mm</td>
			   <td>110mm×110mm×45mm</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">重量/g</td>
			   <td colspan="2">35</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作温度</td>
			   <td colspan="2">-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作湿度</td>
			   <td colspan="2">20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">抗干扰性</td>
			   <td colspan="2">符合电磁兼容3级标准</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作电压</td>
			   <td colspan="2">12~30VDC</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">消耗功率</td>
			   <td>＜3W</td>
			   <td>＜5W</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">从设备数量</td>
			   <td colspan="2">16</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">从设备AI、AQ/AI、AQ</td>
			   <td colspan="2">16字、16字/256位、256位</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：DIO3000用户使用手册',
							downloadName:'manual|DIO3000用户使用手册.pdf'
						},
						{
							displayName:'文档：DIO2000产品接线图',
							downloadName:'manual|DIO2000.jpg'
						},
						{
							displayName:'文档：DIO3000产品接线图',
							downloadName:'manual|DIO3000.jpg'
						}
					]
				}
			} else if (TypeID == 17) {

			} else if (TypeID == 18) {

			} else if (TypeID == 19 || TypeID == 20 || TypeID == 21 || TypeID == 22) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/EDC3000&5000&8000.png')
						// require('@/assets/images/edge/products/details/EDC3200.png'),
						// require('@/assets/images/edge/products/details/EDC5000-aodo.png'),
						// require('@/assets/images/edge/products/details/EDC8000.png'),
					],
					SerialName: '可编程嵌入式开发平台EDC系列',
					SerialIntro: 'EDC:Embeded Development Controller<br/>嵌入式控制器采用卧式壳体形式，具备全分布式控制、多种网络集成、数据采集、远程监控等功能，为各类复杂工程应用提供低成本、高效能的通用解决方案，实现了工厂协同自动化。<br/>',
					TypeInfo: [
						{
							TypeName: 'EDC3200',
							TypeIntro: 'EDC3200是一种支持多种通信协议，具有逻辑控制、过程控制、运动控制功能的分布式网络化PLC。支持IEC61131-3 标准的梯形图、功能块编程，具有逻辑指令，运算指令，定时/计数器指令，控制指令，中断指令，网络通信指令和专用指令等，指令集丰富。支持EPA、Modbus、Profibus-DP、MPI等主流控制网络协议，具有多级主从设备扩展和第三方设备互连的能力。以网络系统为整体，对系统中的设备进行统一管理和编程开发，可以实现大中小型可编程控制系统的各种功能。<br/>特点：开关量<br/>·24路DI<br/>·16路DQ(继电器)<br/>·2路RS485接口<br/>·1路100M以太网接口'
						},
						{
							TypeName: 'EDC5000',
							TypeIntro: 'EDC5000是一种支持多种通信协议，具有逻辑控制、过程控制、运动控制功能的分布式网络化PLC。支持IEC61131-3 标准的梯形图、功能块编程，具有逻辑指令，运算指令，定时/计数器指令，控制指令，中断指令，网络通信指令和专用指令等，指令集丰富。支持EPA、Modbus、Profibus-DP、MPI等主流控制网络协议，具有多级主从设备扩展和第三方设备互连的能力。以网络系统为整体，对系统中的设备进行统一管理和编程开发，可以实现大中小型可编程控制系统的各种功能。<br/>特点：模拟量，有AO，DO两个版本<br/>·2路RS485接口<br/>·1路100M以太网接口<br/>·AO版本：8路AI、8路AQ，4路DI，2路DQ<br/>·DO版本：8路AI、无AO，4路DI、9路DQ'
						},
						{
							TypeName: 'EDC8000',
							TypeIntro: 'EDC8000控制器是一种支持多种通信协议，具有逻辑控制、过程控制、运动控制功能的分布式网络化PLC。支持IEC61131-3 标准的梯形图、功能块编程，具有逻辑指令，运算指令，定时/计数器指令，控制指令，中断指令，网络通信指令和专用指令等，指令集丰富。支持EPA、Modbus、Profibus-DP、MPI等主流控制网络协议，具有多级主从设备扩展和第三方设备互连的能力。以网络系统为整体，对系统中的设备进行统一管理和编程开发，可以实现大中小型可编程控制系统的各种功能。<br/>·6路AI，2路AQ<br/>·8路DI，9路DQ，其中4路高速DI,2路高速DQ<br/>·2路RS485接口<br/>·1路100M以太网接口'
						}
					],
					ParaTable: `<table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="3"><a>技术规格</a></td>
			   <td><a>EDC3200</a></td>
			   <td><a>EDC5000-AQ</a></td>
			   <td><a>EDC3000-DQ</a></td>
			   <td><a>EDC8000</a></td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="2">数字量输入</td>
			   <td colspan="2" class="para-table-tag">输入点数</td>
			   <td >24路普通</td>
			   <td >4路普通</td>
			   <td >4路普通</td>
			   <td >4路普通<br />
				   +4路高速</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入类型</td>
			   <td colspan="4">双向输入</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="2">数字量输出</td>
			   <td colspan="2" class="para-table-tag">输出点数</td>
			   <td>16路普通</td>
			   <td>2路普通</td>
			   <td>9路普通</td>
			   <td>7路普通<br />
				   +2路高速</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输出类型</td>
			   <td colspan="4">NPN或PNP晶体管输出或继电器输出</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="8">模拟量输入</td>
			   <td colspan="2" class="para-table-tag">输入数量</td>
			   <td>--</td>
			   <td>8路普通</td>
			   <td>8路普通</td>
			   <td>6路普通</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入类型</td>
			   <td colspan="4">热电偶：K、E、S、T、R、N、J、B、W<br />
				   热电阻：Pt100、Cu50、Cu100、Ni120<br />
				   电压：-5V~5V、-10V~10V、0~5V、1~5V、0~50mV<br />
				   电流：0~20mA、4~20mA</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="6">分辨率</td>
			   <td class="para-table-tag" rowspan="2">温度</td>
			   <td colspan="4">Pt100:0.01℃</td>
		   </tr>
		   <tr>
			   <td colspan="4">热电阻、热电偶：0.1℃</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="2">电压</td>
			   <td colspan="4">0~5V：2000码/V</td>
		   </tr>
		   <tr>
			   <td colspan="4">0~50mV：300码/mV</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="2">电流</td>
			   <td colspan="4">0~20mA：500码/mA</td>
		   </tr>
		   <tr>
			   <td colspan="4">4~20mA：500码/mA</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="5">模拟量输出</td>
			   <td colspan="2" class="para-table-tag">输出数量</td>
			   <td>--</td>
			   <td>8路普通</td>
			   <td>--</td>
			   <td>2路普通</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">模拟量输出范围</td>
			   <td colspan="4">0~20V（0~20000码）、0~10V（0~10000码）、<br />
				   0~5V（0~5000码）；0~20mA（0~5000码）、<br />
				   4~20mA（1000~5000码）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">分辨率</td>
			   <td colspan="4">0.1%FS</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">带负载能力</td>
			   <td colspan="4">电压型 &lt;50mA</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">过流保护</td>
			   <td colspan="4">50mA，自恢复型</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">用户程序存储器</td>
			   <td>96K字</td>
			   <td>96K字</td>
			   <td>96K字</td>
			   <td>256K字</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">电池保持存储器</td>
			   <td>0</td>
			   <td>10.5K字</td>
			   <td>10.5K字</td>
			   <td>123字</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">数据存储器</td>
			   <td>10.5K字</td>
			   <td>10.5K字</td>
			   <td>10.5K字</td>
			   <td>32K字</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">非易失存储器</td>
			   <td>4K字</td>
			   <td>2K字</td>
			   <td>2K字</td>
			   <td>20K字</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">定时器总数</td>
			   <td colspan="4">128</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">计数器总数</td>
			   <td colspan="4">128</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">定时器中断</td>
			   <td colspan="4">8</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">IO中断</td>
			   <td>8</td>
			   <td>8</td>
			   <td>2</td>
			   <td>8</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">实时时钟</td>
			   <td colspan="4">支持</td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">RS485通信</td>
			   <td colspan="2" class="para-table-tag">端口数</td>
			   <td colspan="4">2</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通信速率</td>
			   <td colspan="4">9600bps-115200bps、500Kbps、1Mbps</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通信协议</td>
			   <td colspan="4">Modbus/MB+/Profibus-DP</td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">以太网通信</td>
			   <td colspan="2" class="para-table-tag">端口数</td>
			   <td colspan="4">1</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通信速率</td>
			   <td colspan="4">10/100Mbps</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通信协议</td>
			   <td colspan="4">EPA/Modbus TCP<br />
				   /Modbus UDP</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">尺寸/mm</td>
			   <td colspan="4">146mm×98mm×45mm</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">重量/g</td>
			   <td colspan="4">380</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">工作温度</td>
			   <td colspan="4">-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">工作湿度</td>
			   <td colspan="4">20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">抗干扰性</td>
			   <td colspan="4">符合电磁兼容3级标准</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">工作电压</td>
			   <td colspan="4">12~30VDC</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">消耗功率</td>
			   <td colspan="4">＜5W</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">从设备数量</td>
			   <td colspan="4">16</td>
		   </tr>
		   <tr>
			   <td colspan="3" class="para-table-tag">从设备AI、AQ/DI、DQ</td>
			   <td colspan="4">16字、16字/256位、256位</td>
		   </tr>
		   </table>`,
					DownloadList: [						
						{
							displayName:'文档：EDC8000用户使用手册',
							downloadName:'manual|EDC8000用户使用手册.pdf'
						},
						{
							displayName:'文档：EDC3000产品接线图',
							downloadName:'manual|EDC3000.jpg'
						},
						{
							displayName:'文档：EDC5000-AO产品接线图',
							downloadName:'manual|EDC5000-AO.jpg'
						},
						{
							displayName:'文档：EDC5000-DO产品接线图',
							downloadName:'manual|EDC5000-DO.jpg'
						},
						{
							displayName:'文档：EDC8000接线图',
							downloadName:'manual|EDC8000接线图.pdf'
						}
					]
				}
			} else if (TypeID == 23 || TypeID == 24 || TypeID == 25 || TypeID == 26) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/CIO110&200&210&300.png'),
					],
					SerialName: 'CIO系列小型控制器',
					SerialIntro: 'CIO:Controller with extend Input and Output',
					TypeInfo: [{
							TypeName: 'CIO110',
							TypeIntro: 'CIO110具有一定的数据存储空间和程序存储空间，支持多种串口通信协议，支持IO扩展功能，最多可扩展16个IO模块，可扩展上百个IO点，体积小巧，结构紧凑、安装方便，通过统一编程控制完成各种自动化控制，单独使用时可用于单机及小型自动控制，适用于中等点数、功能简单、成本超低的低端市场需求。<br/>·11路DI<br/>·8路DO<br/>·2路RS485接口'
						},						
						{
							TypeName: 'CIO314',
							TypeIntro: 'CIO310 控制器是一种支持多种通信协议，具有逻辑控制、过程控制功能的 PLC。支持 IEC61131-3 标准的梯形图、功能块编程，具有逻辑指令，运算指令，定时/计数指令，控制指令，中断指令，串行通信指令和专用指令等，指令集丰富。支持EPA、Modbus等主流控制网络协议，具有多级主从设备扩展和第三方设备互连的能力。<br/>·15路DI，其中前4路支持高速输入<br/>·10路DO，继电器输出<br/>·3路RS485接口'
						},
						{
							TypeName: 'CIO200',
							TypeIntro: 'CIO200最大的优势是带有DB9接口的RS232，作为专用编程口（115200bps），无需转接器可直接与上位机通信。该产品采用卧式结构，端子可整体插拔，接线方便。CIO200的物理输入、输出点采用4:3比例划分，适用于多数小型控制柜，CIO200具有2个RS485和1个RS232口，具有强大的串口通信能力。通过独立编程控制完成各种自动化控制，自身带一定数量的IO点，可独立完成一些小型自动控制，适用于中等点数、功能简单、成本超低的低端市场需求。<br/>·16路DI<br/>·12路DO<br/>·2路RS485接口<br/>·1路RS232接口'
						},
						{
							TypeName: 'CIO210',
							TypeIntro: 'CIO210与CIO200的功能基本相同。特色：具有高速输入通道。<br/>·16路DI<br/>·16路DO<br/>·1路RS485接口<br/>·1路RS232接口'
						}
					],
					ParaTable: `<table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="2" width="300"><a>技术规格</a></td>
			   <td><a>CIO110</a></td>
			   <td><a>CIO200</a></td>
			   <td><a>CIO210</a></td>
			   <td><a>CIO310</a></td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入点数</td>
			   <td>11</td>
			   <td>16</td>
				<td>16</td>
			   <td>15</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入类型</td>
			   <td>双向输入</td>
			   <td>双向输入</td>
				<td>双向输入</td>
			   <td>双向输入</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输出点数</td>
			   <td>8</td>
			   <td>12</td>
				<td>16</td>
			   <td>10</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输出类型</td>
			   <td>晶体管</td>
			   <td>晶体管</td>
				<td>晶体管</td>
			   <td>晶体管</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">用户程序存储器</td>
			   <td colspan="4">96K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数据存储器</td>
			   <td colspan="4">8K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">非易失存储器</td>
			   <td colspan="4">4K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">定时器总数</td>
			   <td colspan="4">128</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">计数器总数</td>
			   <td colspan="4">128</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">定时器中断</td>
			   <td colspan="4">8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">外部中断</td>
			   <td colspan="4">8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">实时时钟</td>
			   <td colspan="4">支持</td>
		   </tr>
		   <tr>
			   <td rowspan="4" class="para-table-tag">RS485/RS232通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td>2/-</td>
				<td>2/1</td>
				<td>1/1</td>
			   <td>3/-</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td colspan="4">2400bps、4800bps、9600bps、19200bps、38400bps、57600bps、115200bps、500Kbps、1Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td>Modbus/扩展IO</td>
			   <td>Modbus</td>
				<td>Modbus</td>
			   <td>Modbus/扩展IO</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">最大IO设备数量</td>
			   <td>16</td>
			   <td>--</td>
				<td>--</td>
			   <td>16</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">尺寸/mm</td>
			   <td>23mm×120mm×110mm</td>
			   <td>125mm×90mm×68.5mm</td>
				<td>125mm×90mm×68.5mm</td>
			   <td>40mm×114mm×104mm</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作温度</td>
			   <td colspan="4">-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作湿度</td>
			   <td colspan="4">20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">抗干扰性</td>
			   <td colspan="4">符合IEC61000-4-4标准,2KV</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作电压</td>
			   <td colspan="3">9~30VDC</td>
			   <td>150~260VDC</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">消耗功率</td>
			   <td>＜1W</td>
			   <td>＜1W</td>
			   <td>＜1W</td>
				<td>＜1W</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：CIO110用户使用手册',
							downloadName:'manual|CIO110用户使用手册.pdf'
						},
						{
							displayName:'文档：CIO200用户使用手册',
							downloadName:'manual|CIO200用户使用手册.pdf'
						},
						{
							displayName:'文档：CIO210可编程控制器使用手册',
							downloadName:'manual|CIO210可编程控制器使用手册V1.0.pdf'
						},
						{
							displayName:'文档：CIO300系列可编程控制器使用手册',
							downloadName:'manual|CIO300系列可编程控制器使用手册_V1.1 .pdf'
						}
					]
				}
			} else if (TypeID == 27 || TypeID == 28) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/EIO102&103.png'),
					],
					SerialName: '开关量输入模块',
					SerialIntro: '扩展IO模块支持底板总线HEBus网络，可以作为MAC系列主控器的输入输出扩展模块使用。<br/>开关量输入扩展模块EIO100系列',
					TypeInfo: [{
						TypeName: 'EIO102 & EIO103',
						TypeIntro: 'EIO102 & EIO103是一款数字量输入的扩展IO设备，该产品可用于连接标准开关和2线制接近开关(BERO)等，主要适用于开关量控制场合.抗干扰能力通过电磁兼容3级标准，所有接口都具备隔离电路，稳定性强支持标准Modbus协议，可作任意设备的第三方I/O扩展设备。支持端子可拆卸、带电插拔等多种实用性功能，且产品体积小巧，节省空间。可用于钢铁、冶金、电力、水泥、医药等流程行业以及纺织机械、塑料机械、电子产品制造、包装机械等装备制造等。<br/>·1路RS485<br/>·EIO102 16路DI<br/>·EIO103 20路DI'
					}],
					ParaTable: `<table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="2" width="300px"><a>技术规格</a></td>
			   <td><a>EIO101</a></td>
			   <td><a>EIO102</a></td>
			   <td><a>EIO103</a></td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">RS485通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td colspan="3">1</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td colspan="3">2400bps、4800bps、9600bps、19200bps、38400bps、57600bps、115200bps、500Kbps、1Mbps、2Mbps、3Mbps、4Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td colspan="3">Modbus/扩展IO</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数字量输入点数</td>
			   <td>8</td>
			   <td>16</td>
			   <td>20</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数字量输入类型</td>
			   <td colspan="3">双向输入</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">尺寸/mm</td>
			   <td colspan="3">23mm×120mm×110mm</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">重量/g</td>
			   <td colspan="3">150</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作温度</td>
			   <td colspan="3">-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作湿度</td>
			   <td colspan="3">20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">抗干扰性</td>
			   <td colspan="3">符合IEC61000-4-4标准,2KV</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作电压</td>
			   <td colspan="3">9~30VDC</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">消耗功率</td>
			   <td colspan="3">＜1W</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：EIO&EA系列产品用户使用手册',
							downloadName:'manual|EIO&EA系列产品用户使用手册.pdf'
						}
					]
				}
			} else if (TypeID == 29 || TypeID == 30 || TypeID == 31 || TypeID == 32 || TypeID == 33 || TypeID == 34) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/EIO162&163&171&172.png'),
					],
					SerialName: '开关量输出模块',
					SerialIntro: '扩展IO模块支持底板总线HEBus网络，可以作为MAC系列主控器的输入输出扩展模块使用。<br/>开关量输出扩展模块EIO160/EIO170系列',
					TypeInfo: [{
							TypeName: 'EIO162 & EIO162P',
							TypeIntro: 'EIO162 & EIO162P 是一款带有光耦隔离的数字量输出的扩展IO设备，该产品可用于连接小功率继电器、直流接触器、指示灯和电机启动器等，主要适用于开关量控制场合，性能更稳定。抗干扰能力通过电磁兼容3级标准，所有接口都具备隔离电路，稳定性强支持标准Modbus协议，可作任意设备的第三方I/O扩展设备。支持端子可拆卸、带电插拔等多种实用性功能，且产品体积小巧，节省空间。可用于钢铁、冶金、电力、水泥、医药等流程行业以及纺织机械、塑料机械、电子产品制造、包装机械等装备制造等。<br/>·1路RS485<br/>·16路DO<br/>·EIO162 晶体管NPN输出型，EIO162P晶体管PNP输出型'
						},
						{
							TypeName: 'EIO163 & EIO163P',
							TypeIntro: 'EIO163 & EIO163P 功能与通道类型与EIO162 & EIO162P相同，区别是通道数不同<br/>·1路RS485<br/>·20路DO<br/>·EIO163 晶体管NPN输出型，EIO163P晶体管PNP输出型'
						},
						{
							TypeName: 'EIO171 & EIO172',
							TypeIntro: 'EIO171 & EIO172 是一款继电器输出的扩展IO设备，该产品可以直接连接交流接触器、控制阀门、电磁阀等，该产品可有效的消除电弧，保护触点，性能更稳定。抗干扰能力通过电磁兼容3级标准，所有接口都具备隔离电路，稳定性强支持标准Modbus协议，可作任意设备的第三方I/O扩展设备。支持端子可拆卸、带电插拔等多种实用性功能，且产品体积小巧，节省空间。可用于钢铁、冶金、电力、水泥、医药等流程行业以及纺织机械、塑料机械、电子产品制造、包装机械等装备制造等。<br/>·1路RS485<br/>·通道类型：继电器，30VDC/250VAC 2A<br/>·EIO171 8路DO，EIO172 16路DO'
						}

					],
					ParaTable: `<table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="2" width="300px"><a>技术规格</a></td>
			   <td><a>EIO160系列</a></td>
			   <td><a>EIO170系列</a></td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">RS485通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td colspan="2">1</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td colspan="2">2400bps、4800bps、9600bps、19200bps、38400bps、57600bps、115200bps、500Kbps、1Mbps、2Mbps、3Mbps、4Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td colspan="2">Modbus/扩展IO</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数字量输出点数</td>
			   <td>8/16/20</td>
			   <td>8/16</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数字量输出类型</td>
			   <td>NMOS开漏输出，负载电流小于150mA</td>
			   <td>继电器输出，AC 250V/2A，DC 30V/2A</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">尺寸/mm</td>
			   <td colspan="2">23mm×120mm×110mm</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">重量/g</td>
			   <td>150</td>
			   <td>350</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作温度</td>
			   <td colspan="2">-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作湿度</td>
			   <td colspan="2">20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">抗干扰性</td>
			   <td colspan="2">符合IEC61000-4-4标准,2KV</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作电压</td>
			   <td colspan="2">9~30VDC</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">消耗功率</td>
			   <td>＜1W</td>
			   <td>＜5W</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：EIO&EA系列产品用户使用手册',
							downloadName:'manual|EIO&EA系列产品用户使用手册.pdf'
						}
					]
				}
			} else if (TypeID == 35 || TypeID == 36 || TypeID == 37 || TypeID == 38) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/EA201&211&122&131.png'),
					],
					SerialName: '模拟量输入模块',
					SerialIntro: '扩展IO模块支持底板总线HEBus网络，可以作为MAC系列主控器的输入输出扩展模块使用。<br/>模拟量输入模块EA200系列和EA210系列',
					TypeInfo: [{
							TypeName: 'EA20x系列',
							TypeIntro: 'EA20x系列 是一款模拟量输入的扩展IO设备，该设备支持标准电流、标准电压传感器类型，抗干扰能力通过电磁兼容3级标准，所有接口都具备隔离电路，将AI输入电源隔离提高整个系统的稳定性，支持标准Modbus协议，可作任意设备的第三方I/O扩展设备。支持端子可拆卸、带电插拔等多种实用性功能，且产品体积小巧，节省空间。可用于钢铁、冶金、电力、水泥、医药等流程行业以及纺织机械、塑料机械、电子产品制造、包装机械等装备制造等。<br/>EA20x系列都有用6个通道，区别是通道类型不同<br/>·1路RS485<br/>·6路AI<br/>·EA201 电流电压<br/>·EA202 热电偶输入<br/>·EA203 PT100<br/>·EA204 -10~+10V<br/>·EA205 PT1000<br/>·EA206 高精度PT1000<br/>·EA207 S/R铂热电偶<br/>·EA208 B铂热电偶'
						},
						{
							TypeName: 'EA21x系列',
							TypeIntro: 'EA21x系列功能与EA20x系列相同，区别是EA20x系列拥有6个通道，EA21x系列拥有8个通道。<br/>·1路RS485<br/>·8路AI<br/>·EA211 电流电压<br/>·EA212 热电偶输入<br/>·EA213 PT100<br/>·EA214 -10~+10V<br/>·EA215 PT1000<br/>·EA216 高精度PT1000<br/>·EA217 S/R铂热电偶<br/>·EA218 B铂热电偶'
						},
						{
							TypeName: 'EA122',
							TypeIntro: '也是相同功能的扩展IO设备。拥有最多的12路通道。<br/>·1路RS485<br/>·12路AI(热电偶)'
						},
						{
							TypeName: 'EA131',
							TypeIntro: '也是相同功能的扩展IO设备。具有高速模拟量采集的功能。<br/>·1路RS485<br/>·8路AI(电流/电压)'
						}
					],
					ParaTable: `<table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="2" width="250"><a>技术规格</a></td>
			   <td ><a>EA200系列</a></td>
			   <td><a>EA210系列</a> </td>
			   <td><a>EA120系列</a></td>
			   <td><a>EA130系列</a></td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">RS485通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td colspan="4">1</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td colspan="4">2400bps、4800bps、9600bps、19200bps、38400bps、57600bps、115200bps、500Kbps、1Mbps、2Mbps、3Mbps、4Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td colspan="4">Modbus/扩展IO</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">模拟量输入点数</td>
			   <td>6</td>
			   <td>8</td>
			   <td>12</td>
			   <td>8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">模拟量输入类型</td>
			   <td colspan="2">热电偶：K/E/S/T/R<br />/E/N/J/B<br />热电阻：Pt100/Cu50<br /> /Ni120<br />电压：0-5V<br />电流：4-20mA</td>
			   <td>热电偶：K/E/S/T/<br />R/E/N/J/B</td>
			   <td>0-20mA、<br />0-5V</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">分辨率</td>
			   <td colspan="2"> 0.1℃/0.01℃ 2000码/V</td>
			   <td>0.1℃</td>
			   <td>1000码/V</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">尺寸/mm</td>
			   <td>18mm×120mm×110mm</td>
			   <td colspan="3">23mm×120mm×110mm（后3系列产品尺寸）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">重量/g</td>
			   <td colspan="4">150</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作温度</td>
			   <td colspan="4">-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作湿度</td>
			   <td colspan="4">20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">抗干扰性</td>
			   <td colspan="4">符合IEC 61000-4-4标准，2KV</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作电压</td>
			   <td colspan="4">9~30VDC</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">消耗功率</td>
			   <td colspan="4">＜1W</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：EIO&EA系列产品用户使用手册',
							downloadName:'manual|EIO&EA系列产品用户使用手册.pdf'
						}
					]
				}
			} else if (TypeID == 39 || TypeID == 40 || TypeID == 41) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/EA155&156.png'),
					],
					SerialName: '模拟量输出模块',
					SerialIntro: '扩展IO模块支持底板总线HEBus网络，可以作为MAC系列主控器的输入输出扩展模块使用。<br/>模拟量输出模块EA150系列和EA160系列',
					TypeInfo: [{
							TypeName: 'EA155 & EA156',
							TypeIntro: 'EA155 & EA156是模拟量输出的扩展IO设备，该产品支持电流输出，分辨率为250码/mA，广泛用于模拟量输出场合。抗干扰能力通过电磁兼容3级标准，所有接口都具备隔离电路，稳定性强支持标准Modbus协议，可作任意设备的第三方I/O扩展设备。支持端子可拆卸、带电插拔等多种实用性功能，且产品体积小巧，节省空间。可用于钢铁、冶金、电力、水泥、医药等流程行业以及纺织机械、塑料机械、电子产品制造、包装机械等装备制造等。<br/>两种型号的功能，通道类型相同，但通道个数不同。<br/>·1路RS485<br/>EA155 4路AO(0~20mA)，EA156 8路AO(0~20mA)'
						},
						{
							TypeName: 'EA165 & EA166',
							TypeIntro: '功能都完全相同，区别是通道类型不同。<br/>·1路RS485<br/>EA165 4路AO(0~20V)，EA166 8路AO(0~20V)'
						},
						{
							TypeName: 'EA167 & EA168',
							TypeIntro: '功能都完全相同，区别是通道类型不同。<br/>·1路RS485<br/>EA167 4路AO(-10~10V)，EA168 8路AO(-10~10V)'
						}
					],
					ParaTable: `<table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="2" width="250"><a>技术规格</a></td>
			   <td ><a>EA150系列</a></td>
			   <td ><a>EA160系列</a></td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">RS485通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td colspan="2">1</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td colspan="2">2400bps、4800bps、9600bps、19200bps、38400bps、57600bps、115200bps、500Kbps、1Mbps、2Mbps、3Mbps、4Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td colspan="2">Modbus/扩展IO</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输出点数</td>
			   <td>4/8</td>
			   <td>4/8/4/8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输出类型</td>
			   <td>0~20mA</td>
			   <td>0~20V/-10~10V</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">分辨率</td>
			   <td>250码/mA</td>
			   <td>1000码/mV</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">尺寸/mm</td>
			   <td colspan="2">23mm×120mm×110mm</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">重量/g</td>
			   <td colspan="2">150</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作温度</td>
			   <td colspan="2">-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作湿度</td>
			   <td colspan="2">20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">抗干扰性</td>
			   <td colspan="2">符合IEC 61000-4-4标准，2KV</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作电压</td>
			   <td colspan="2">9~30VDC</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">消耗功率</td>
			   <td colspan="2">＜1W</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：EIO&EA系列产品用户使用手册',
							downloadName:'manual|EIO&EA系列产品用户使用手册.pdf'
						}
					]
				}
			} else if (TypeID == 42 || TypeID == 43) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/EA170.png'),
					],
					SerialName: '模拟量输入输出模块',
					SerialIntro: '扩展IO模块支持底板总线HEBus网络，可以作为MAC系列主控器的输入输出扩展模块使用。<br/>模拟量输出模块EA170系列',
					TypeInfo: [{
							TypeName: 'EA171~EA175',
							TypeIntro: `是一款模拟量输入输出的扩展IO设备，广泛用于模拟量输出场合。抗干扰能力通过电磁兼容3级标准，所有接口都具备隔离电路，稳定性强支持标准Modbus协议，可作任意设备的第三方I/O扩展设备。支持端子可拆卸、带电插拔等多种实用性功能，且产品体积小巧，节省空间。可用于钢铁、冶金、电力、水泥、医药等流程行业以及纺织机械、塑料机械、电子产品制造、包装机械等装备制造等。
<br/>型号划分：
<br/>·8路输入输出模块。其中4路输入，4路输出。输出通道类型统一为 2路4-20mA + 2路0-20V。输入通道类型各不相同
<br/>·1路RS485
<br/>·输出通道：2路4-20mA模拟量输出/2路0-20V模拟量输出
<br/>·EA171 4路模拟量输入，每路可单独设置0-5V或4-20mA 
<br/>·EA172 4路热电偶模拟量输入<br/>·EA173 4路PT100热电阻模拟量输入
<br/>·EA174 4路-5~5V、-20~20mA模拟量输入
<br/>·EA175 4路PT1000热电阻模拟量输入`
						},
						{
							TypeName: 'EA176~EA177',
							//TypeIntro: '这3个型号提供高精度的模拟量输入。<br/>各型号的区别：都是4路AI，2路AO，输出的通道类型都为2路电压和2路电流。输入的通道类型各有不同<br/>·1路RS485<br/>·输出通道：2路4-20mA模拟量输出/2路0-20V模拟量输出<br/>·EA176 高精度4路PT1000热电阻模拟量输入<br/>·EA177 高精度4路S/R铂热电偶模拟量输入<br/>·EA178 4路高精度B铂热电偶模拟量输入'
							TypeIntro:`这三款型号均提供高精度的模拟量输入，其主要区别在于输入通道类型的不同。
</br>每个型号均具备4路模拟量输入（AI）和4路模拟量输出（AO），输出通道均包含2路电压输出和2路电流输出。
</br>此外，均配有1路RS485通讯接口。
</br>输出通道：2路4-20mA电流输出 + 2路0-20V电压输出
</br>EA176：高精度4路PT1000热电阻输入
</br>EA177：高精度4路S型和R型铂热电偶输入
</br>EA178：高精度4路B型铂热电偶输入`

						}
					],
					ParaTable: `<table class="para-table"">
		   <tr class="para-table-head">
			   <td colspan="2" width="300"><a>技术规格</a></td>
			   <td><a>EA171</a></td>
			   <td><a>EA172</a></td>
			   <td><a>EA173</a></td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">RS485通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td colspan="3">1</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td colspan="3">2400bps、4800bps、9600bps、19200bps、38400bps、57600bps、115200bps、500Kbps、1Mbps、2Mbps、3Mbps、4Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td colspan="3">Modbus/扩展IO</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">模拟量输入点数</td>
			   <td>4</td>
			   <td>4</td>
			   <td>4</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">模拟量输入类型</td>
			   <td>电压电流型</td>
			   <td>K型热电偶</td>
			   <td>PT100热电阻</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">模拟量输出点数</td>
			   <td>2</td>
			   <td>2</td>
			   <td>2</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">模拟量输出类型</td>
			   <td colspan="3">电压电流型</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">尺寸/mm</td>
			   <td colspan="3">23mm×120mm×110mm</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">重量/g</td>
			   <td colspan="3">150</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作温度</td>
			   <td colspan="3">-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作湿度</td>
			   <td colspan="3">20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">抗干扰性</td>
			   <td colspan="3">符合IEC61000-4-4标准,2KV</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作电压</td>
			   <td colspan="3">9~30VDC</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">消耗功率</td>
			   <td colspan="3">＜1W</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：EIO&EA系列产品用户使用手册',
							downloadName:'manual|EIO&EA系列产品用户使用手册.pdf'
						}
					]
				}
			} else if (TypeID == 44) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/CPS200.png'),
					],
					SerialName: '电源模块',
					SerialIntro: '',
					TypeInfo: [{
						TypeName: 'CPS200',
						TypeIntro: 'CPS200提供了2路隔离的24V输出，分别为主电源和辅助电源。主电源通过底板总线连接器给主控器和IO模块供电；辅助电源通过侧面端子给主控器的辅助电源输入端和IO模块的公共端供电。CPS200主要用于对MAC系列产品进行供电，使用该电源会显著提升控制器的整体抗干扰能力。<br/>·电压输入范围：150~260VAC<br/>·双路24V 4A输出，两路之间相互隔离<br/>·效率高达84%以上，空载功耗小于2W<br/>·较宽的工作温度范围：-30~50℃<br/>·通过IEC61000-4-4抗干扰试验<br/>·有完整的保护措施：电源过载、输出短路保护、输出过流'
					}],
					ParaTable: ` <table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="2" width="250px"><a>技术规格</a></td>
			   <td ><a>CPS200</a></td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">输入</td>
			   <td class="para-table-tag">电压范围</td>
			   <td>150-260VAC</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">频率范围</td>
			   <td>50-60Hz</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">效率</td>
			   <td>84%</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="5">输出点数</td>
			   <td class="para-table-tag">直流电压</td>
			   <td>24V×2</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">额定电流</td>
			   <td>2A×2</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">额定功率</td>
			   <td>96W</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">纹波</td>
			   <td>100mV</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">电压调整范围</td>
			   <td>主路：23.5V-24.5V，辅路：21.5V-26.5V</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="2">保护</td>
			   <td class="para-table-tag">短路保护</td>
			   <td>具有自动恢复功能</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">过温保护</td>
			   <td>保护温度140℃，具有自恢复功能</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="2">环境</td>
			   <td class="para-table-tag">工作温度</td>
			   <td>-30℃~50℃</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">工作湿度</td>
			   <td>20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">电磁干扰度</td>
			   <td>符合电磁兼容4级标准</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="2">其它</td>
			   <td class="para-table-tag">尺寸/mm</td>
			   <td>114mm×104mm×40mm</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">重量/g</td>
			   <td>330</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：MAC系列可编程控制器使用手册(内含电源模块的连接使用)',
							downloadName:'manual|MAC系列可编程控制器使用手册2019.pdf'
						}
					]
				}
			} else if (TypeID == 45) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/EPM102.png'),
					],
					SerialName: '电力监控扩展模块-EPM100系列',
					SerialIntro: '',
					TypeInfo: [{
						TypeName: 'EPM102',
						TypeIntro: 'EPM102控制器是一种支持多种串口通信协议扩展型采集模块。支持Modbus主流控制网络协议，具有主从设备扩展和第三方设备互连的能力。以网络系统为整体，对系统中的设备进行统一管理和编程开发，可以实现大中小型可编程控制系统的各种功能<br/>·1路RS485<br/>·12路AI（3路电压，9路电流）'
					}],
					ParaTable: `<table class="para-table"">
		   <tr class="para-table-head">
			   <td colspan="2"><a>技术规格</a></td>
			   <td><a>EPM101</a></td>
			   <td><a>EPM102</a></td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">电压通道数</td>
			   <td>1</td>
			   <td>3</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通道类型</td>
			   <td>0~9V</td>
			   <td>0~9V</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">电流通道数</td>
			   <td>11</td>
			   <td>9</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通道类型</td>
			   <td>0~5A</td>
			   <td>0~5A</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通道参数</td>
			   <td colspan="2">0~9V:分辨率 0.01V<br />0~ 5A:分辨率 0.01A</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">频率</td>
			   <td colspan="2">分辨率:0.5Hz<br />范围：0~400HZ</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">功率因数</td>
			   <td colspan="2">范围:-1.00~1.00<br />精度：0.1%</td>
		   </tr>
		   <tr>
			   <td rowspan="4" class="para-table-tag">RS485通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td colspan="2">1</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td colspan="2">1200bps~1Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td colspan="2">MODBUS RTU/ASCⅡ从站</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">线缆长度</td>
			   <td colspan="2">屏蔽双绞线最长 1200米（低速）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">电压范围</td>
			   <td colspan="2">电源供电范围9V~30V</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作电流</td>
			   <td colspan="2">小于50mA</td>
		   </tr>
		   <tr>
			   <td colspan="2" rowspan="2" class="para-table-tag">启动电流</td>
			   <td colspan="2">0.6A</td>
		   </tr>
		   <tr>
			   <td colspan="2">持续4ms</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">启动延时</td>
			   <td colspan="2">250ms</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">最大功耗</td>
			   <td colspan="2">小于5W</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">温度</td>
			   <td colspan="2">-40℃~+85℃</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">相对湿度</td>
			   <td colspan="2">5%~95%（不结露）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工业防护级别</td>
			   <td colspan="2">IP20</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">电磁兼容性（EMC）</td>
			   <td colspan="2">通过4级</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">通风散热</td>
			   <td colspan="2">通风良好，自然散热</td>
		   </tr>
		   <tr>
			   <td colspan="4">使用环境中不允许存放易燃爆，有腐蚀性的气体或物品</td>
		   </tr>
		   <tr>
			   <td colspan="4">使用环境中不允许有强烈的机械振动，冲击和强磁场作用</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'',
							downloadName:''
						}
					]
				}
			} else if (TypeID == 46) {

			} else if (TypeID == 47 || TypeID == 48) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/TAC6000&TAM4000.png'),
					],
					SerialName: '温控及采集模块',
					SerialIntro: '',
					TypeInfo: [{
							TypeName: 'TAC6000',
							TypeIntro: '·通信功能：1路RS485<br/>·8路普通模拟量(AI)输入<br/>·3路普通数字量(DI)输入<br/>·9路普通数字量(DQ)输出'
						},
						{
							TypeName: 'TAM4000',
							TypeIntro: '·通信功能：1路RS485<br/>·8路普通模拟量(AI)输入<br/>·3路普通数字量(DI)输入<br/>·9路普通数字量(DQ)输出'
						}
					],
					ParaTable: `<table class="para-table">
				 <tr>
				   <td bgcolor="#003366" colspan="2" ><font color=white>温控及采集模块</font></td>
				   <td bgcolor="#003366" class="text3">
				   <table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center style="height:25px;font-size:12px">
						   <td width=25%><font color=white>TAC6000</font></td>
						   <td width=25%><font color=white>TAC3000</font></td>
						   <td width=25%><font color=white>TAM4000</font></td>
						   <td><font color=white>DUT4000</font></td>
					   </tr>
				   </table>
				   </td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8"><strong>数字量输入</strong></td>
				   <td align="left" bgcolor="white">
				   <table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=25%>3 路普通</td>
						   <td width=25%>4 路普通</td>
						   <td width=25%>3 路普通</td>
						   <td>--</td>
					   </tr>
				   </table>
				   </td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8"><strong>数字量输出</strong></td>
				   <td align="left" bgcolor="white">
				   <table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=25%>9 路普通</td>
						   <td width=25%>9 路普通</td>
						   <td width=25%>9 路普通</td>
						   <td>--</td>
					   </tr>
				   </table>
				   </td>
				 </tr>
				 <tr>
				   <td colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8"><strong>模拟量输入</strong></td>
				   <td align="left" bgcolor="white">
				   <table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=25%>8 路普通</td>
						   <td width=25%>8 路普通</td>
						   <td width=25%>8 路普通</td>
						   <td>8 路普通</td>
					   </tr>
				   </table>
				   </td>
				 </tr>
				 <tr>
				   <td colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8"><strong>模拟量输出</strong></td>
				   <td align="left" bgcolor="white">
				   <table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=25%>--</td>
						   <td width=25%>--</td>
						   <td width=25%>--</td>
						   <td>--</td>
					   </tr>
				   </table>
				   </td>
				 </tr>
				 <tr>
				   <td colspan="3" align="left" valign="middle" bgcolor="#669cc7" class="text8"><strong>物理特征</strong></td>
				   </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">物理尺寸W×H×D </td>
				   <td align="left" bgcolor="white">

			<table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=25%>35mmx110mmx110mm</td>
						   <td width=25%>146mmx98mmx45mm</td>
						   <td width=25%>35mmx110mmx110mm</td>
						   <td>146mmx98mmx45mm</td>
					   </tr>
				   </table>
			</td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">重量（净重）</td>
				   <td align="left" bgcolor="white">300g</td>
				 </tr>
		 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">功耗</td>
				   <td align="left" bgcolor="white">

		   <table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=25%>小于3W</td>
						   <td width=25%>小于1.5W</td>
						   <td width=25%>小于3W</td>
						   <td>小于1.5W</td>
					   </tr>
				   </table>

			</td>
				 </tr>
		  <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">工作条件</td>
				   <td align="left" bgcolor="white">-40℃~85℃，相对湿度 ≤95%</td>
				 </tr>

				 <tr>
				   <td colspan="3" align="left" valign="middle" bgcolor="#669cc7" class="text8"><strong>程序特征</strong></td>
				   </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">PID回路</td>
				   <td align="left" bgcolor="white"> <table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=50%>8路</td>                           
						   <td>--</td>
					   </tr>
				   </table></td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">PID控制方式</td>
				   <td align="left" bgcolor="white"><table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=50%>位置式PID、 增量式PID、  模糊控制</td>                           
						   <td>--</td>
					   </tr>
				   </table></td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">报警方式</td>
				   <td align="left" bgcolor="white"><table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=50%>绝对值报警、 相对值报警、  预警</td>                           
						   <td>--</td>
					   </tr>
				   </table></td>
				 </tr>
				 <tr>
				   <td colspan="3" align="left" valign="middle" bgcolor="#669cc7" class="text8"><strong>通信功能</strong></td>
				   </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">本机接口RS485</td>
				   <td align="left" bgcolor="white">1路(DUT4000同时具有1路并口通讯)</td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">通信速率</td>
				   <td align="left" bgcolor="white">1200bps~38400bps</td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">通信协议</td>
				   <td align="left" bgcolor="white">支持MODBUS  RTU/ASCⅡ</td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">最大线缆长度</td>
				   <td align="left" bgcolor="white">屏蔽双绞线，小于9600bps时最长1200m</td>
				 </tr>
				 <tr>
				   <td colspan="3" align="left" valign="middle" bgcolor="#669cc7" class="text8"><strong>输入电源特征</strong></td>
				   </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">输入电压</td>
				   <td align="left" bgcolor="white">12V~30VDC</td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">输入电流</td>
				   <td align="left" bgcolor="white">最大，120mA@24VDC</td>
				 </tr>
		<tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">过压保护</td>
				   <td align="left" bgcolor="white">30V</td>
				 </tr>
				 <tr>
				   <td colspan="3" align="left" valign="middle" bgcolor="#669cc7" class="text8"><strong>数字量输入特征</strong></td>
				   </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">输入类型</td>
				   <td align="left" bgcolor="white">
			<table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=75%>NPN型</td>                           
						   <td>--</td>
					   </tr>
				   </table>
			</td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">最大持续电压 </td>
				   <td align="left" bgcolor="white"><table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=75%>30VDC</td>                           
						   <td>--</td>
					   </tr>
				   </table></td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">逻辑信号1 </td>
				   <td align="left" bgcolor="white"><table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=75%>大于10V</td>                           
						   <td>--</td>
					   </tr>
				   </table></td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">逻辑信号0 </td>
				   <td align="left" bgcolor="white"><table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=75%>小于6V</td>                           
						   <td>--</td>
					   </tr>
				   </table></td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">允许漏电流 </td>
				   <td align="left" bgcolor="white"><table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=75%>小于1mA</td>                           
						   <td>--</td>
					   </tr>
				   </table></td>
				 </tr>
				 <tr>
				   <td colspan="3" align="left" valign="middle" bgcolor="#669cc7" class="text8"><strong>数字量输出特征</strong></td>
				   </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">输出类型</td>
				   <td align="left" bgcolor="white"><table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=75%>NPN型晶体管集电极输出，与供电电源共地输出</td>                           
						   <td>--</td>
					   </tr>
				   </table></td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">负载电压范围</td>
				   <td align="left" bgcolor="white"><table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=75%>3V~28VDC</td>                           
						   <td>--</td>
					   </tr>
				   </table></td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">逻辑1</td>
				   <td align="left" bgcolor="white"><table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=75%>小于1V</td>                           
						   <td>--</td>
					   </tr>
				   </table></td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">逻辑0</td>
				   <td align="left" bgcolor="white"><table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=75%>负载电压</td>                           
						   <td>--</td>
					   </tr>
				   </table></td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">负载电流</td>
				   <td align="left" bgcolor="white"><table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=75%>小于140mA</td>                           
						   <td>--</td>
					   </tr>
				   </table></td>
				 </tr>
		<tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">截止电流</td>
				   <td align="left" bgcolor="white"><table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=75%>小于50uA</td>                           
						   <td>--</td>
					   </tr>
				   </table></td>
				 </tr>
		<tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">过滤保护</td>
				   <td align="left" bgcolor="white"><table width="100%" border="0" cellspacing="0" cellpadding="0">
					   <tr align=center>
						   <td width=75%>140mA，自恢复型</td>                           
						   <td>--</td>
					   </tr>
				   </table></td>
				 </tr>
				 <tr>
				   <td colspan="3" align="left" valign="middle" bgcolor="#669cc7" class="text8"><strong>模拟量输入特征</strong></td>
				   </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">模拟量输入类型 </td>
				   <td align="left" bgcolor="white">热电偶：K、E、S、T、R、E、N、J、B、W<br>热电阻：Pt100、Cu50、Cu100、Ni120<br>电压 ：-5V~5V、-10V~10V、0~5V、1~5V、0~50mV<br>电流 ：0~20mA、4~20mA<br>
			</td>
				 </tr>
				 <tr>
				   <td colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8"><strong>分辨率<br>温度<br>电压<br>毫伏电压<br>电流<br>
		</strong></td>
			<td align="left" bgcolor="white"><br>0.1℃/0.01℃<br>2000码/V<br>300码/mV<br>500码/mA<br>
			
			</td>
				   </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">精度</td>
				   <td align="left" bgcolor="white">±0.1℃、±0.05%FSR</td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">转换位数</td>
				   <td align="left" bgcolor="white">15位</td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">转换类型</td>
				   <td align="left" bgcolor="white">双积分</td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">转换时间</td>
				   <td align="left" bgcolor="white">80ms/通道(720ms所有通道)</td>
				 </tr>
				 <tr>
				   <td width="200" colspan="2" align="left" valign="middle" bgcolor="#669cc7" class="text8">滤波</td>
				   <td align="left" bgcolor="white">3次(2.16s所有通道)</td>
				 </tr>
				 
			   </table>`,
					DownloadList: [
						{
							displayName:'文档：TAC6000逻辑输入和输出组态信息定义',
							downloadName:'manual|TAC6000逻辑输入和输出组态信息定义v1.2.pdf'
						},
						{
							displayName:'文档：TAC6000说明书',
							downloadName:'manual|TAC6000说明书.pdf'
						},
						{
							displayName:'文档：TAM4000产品说明书',
							downloadName:'manual|TAM4000产品说明书.pdf'
						}
					]
				}
			} else if (TypeID == 49) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/NCC2040.png'),
					],
					SerialName: '纺织机械专用切丝计长器-NCC2040',
					SerialIntro: '',
					TypeInfo: [{
						TypeName: 'NCC2040',
						TypeIntro: 'NCC2040是一种带用计长器控制功能的可编程控制器，该控制器同时也是具有逻辑控制、过程控制的分布式PLC。支持IEC61131-3标准的梯形图、功能块编程，具有逻辑指令，运算指令，定时/计数指令，控制指令，中断指令，串行通信指令和专用指令等，指令集丰富。通讯协议以MODBUS-RTU为主，开放控制器全部功能，可实现全部参数的设置和读取，另外该控制器还兼容特有的通信协议，可以直接替换以前的计长器产品。<br/>控制器具有计长器功能，开启计长器功能后用户无需编程，便可进行全面的计长器控制。控制器支持定时控制、探丝输入控制、PU保护、禁止切丝输出等控制功能；支持多种切丝模式，包括：单股切丝、双股切丝、三股切丝和四个切丝。为了适用于不同的计长器控制场合，用户还可以利用控制器的可编程功能，通过功能块或梯形图的方式，编写组态工程实现各种控制功能，此外，控制器还提供了通用的计长器功能组态工程，用户可利用该工程进行二次开发，可缩短开发时间。'
					}],
					ParaTable: ` <table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="2"><a>技术规格</a></td>
			   <td><a>NCC2040</a></td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入点数</td>
			   <td>15路（12路探丝器、<br />1路PU保护、<br />1路禁止切丝）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输入类型</td>
			   <td>单向输入</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输出点数</td>
			   <td>24路（12路切丝器<br />、12路指示灯）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">输出类型</td>
			   <td>PMOS输出，负载电流小于1A</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">用户程序存储器</td>
			   <td>96K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数据存储器</td>
			   <td>4K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">非易失存储器</td>
			   <td>2K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">定时器总数</td>
			   <td>128</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">计数器总数</td>
			   <td>128</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">定时器中断</td>
			   <td>8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">外部中断</td>
			   <td>8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">实时时钟</td>
			   <td>--</td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">RS485通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td>1</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td>1200bps-115200bps<br />
				   、500Kbps、1Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td>Modbus RT、Modbus ASCII</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">尺寸/mm</td>
			   <td>160mm×150mm×28mm</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">重量/g</td>
			   <td>520</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作温度</td>
			   <td>-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作湿度</td>
			   <td>20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">抗干扰性</td>
			   <td>符合电磁兼容4级标准</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作电压</td>
			   <td>9~30VDC</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">消耗功率</td>
			   <td>&lt;10W</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：NCC系列说明书',
							downloadName:'manual|NCC系列说明书V1.1.pdf'
						},
						{
							displayName:'文档：NCC2040可编程控制器使用手册',
							downloadName:'manual|NCC2040可编程控制器使用手册_V1.0.pdf'
						}
					]
				}
			} else if (TypeID == 50) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/MCD1000.jpg'),
					],
					SerialName: '起重机监控控制器-MCD1000',
					SerialIntro: '',
					TypeInfo: [{
						TypeName: 'MCD1000',
						TypeIntro: 'MCD1000是一种支持多路数字量输入输出和模拟量输入输出的起重机监控控制器，该控制器同时也是一种支持多种通信协议，具有逻辑控制、过程控制、运动控制功能的分布式网络化PLC。支持SD卡存储功能，能够实现实时数据的文件存储功能。支持IEC61131-3 标准的梯形图、功能块编程，具有逻辑指令，运算指令，定时/计数指令，控制指令，中断指令，网络通信指令和专用指令等，指令集丰富。支持EPA、Modbus、Profibus-DP等主流控制网络协议，具有多级主从设备扩展和第三方设备互连的能力。控制器以网络系统为整体，对系统中的其他设备进行统一监控和管理，可以实现大中小型起重机监控系统或普通可编程控制系统的各种控制功能。<br/>·6路AI，2路AQ<br/>·32路DI，16路DQ(继电器)<br/>·2路RS485接口，2路100M以太网接口<br/>·SD文件系统'
					}],
					ParaTable: ` <table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="2"><a>技术规格</a></td>
			   <td><a>MCD1000</a></td>
		   </tr>
		   <tr>
			   <td rowspan="2" class="para-table-tag">数字量输入</td>
			   <td class="para-table-tag">输入点数</td>
			   <td>28路普通+4路高速（最高输入频率1MHz）</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">输入类型</td>
			   <td>双向输入</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="2">数字量输出</td>
			   <td class="para-table-tag">输出点数</td>
			   <td>16路普通（继电器）</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">输出类型</td>
			   <td>继电器输出</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="3">模拟量输入</td>
			   <td class="para-table-tag">输入数量</td>
			   <td>6路普通</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">输入类型</td>
			   <td>电压：0V~5V&nbsp;<br>电流：4~20mA</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">分辨率</td>
			   <td>2000码/V</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag" rowspan="3">模拟量输出</td>
			   <td class="para-table-tag">输出数量</td>
			   <td>2路普通</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">输出类型</td>
			   <td>电压：0V~10V&nbsp;
				   电流：4~20mA</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">分辨率</td>
			   <td>1000码/V&nbsp; 250码/mA</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">用户程序存储器</td>
			   <td>512K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">电池保持存储器</td>
			   <td>123字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">数据存储器</td>
			   <td>64K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">非易失存储器</td>
			   <td>64K字</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">文件存储卡（SD卡）</td>
			   <td>16GB</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">定时器总数</td>
			   <td>1024</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">计数器总数</td>
			   <td>128</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">定时器中断</td>
			   <td>8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">外部中断</td>
			   <td>8</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">实时时钟</td>
			   <td>支持</td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">RS485通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td>2</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td>1200bps、2400bps、4800bps、9600bps、19200bps、<br />
				   38400bps、57600bps、115200bps、500Kbps、1Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td>Modbus/Profibus-DP/MPI</td>
		   </tr>
		   <tr>
			   <td rowspan="3" class="para-table-tag">以太网通信</td>
			   <td class="para-table-tag">端口数</td>
			   <td>2</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信速率</td>
			   <td>10/100Mbps</td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">通信协议</td>
			   <td>Modbus/Profibus-DP/MPI</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">尺寸/mm</td>
			   <td>212mm×190mm×45mm</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">重量/g</td>
			   <td>528</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作温度</td>
			   <td>-40℃~85℃</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作湿度</td>
			   <td>20%~95%（不结霜）</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">抗干扰性</td>
			   <td>符合电磁兼容3级标准</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">工作电压</td>
			   <td>24~26VDC</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">消耗功率</td>
			   <td>＜10W</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">从设备数量</td>
			   <td>16</td>
		   </tr>
		   <tr>
			   <td colspan="2" class="para-table-tag">从设备AI、AQ/DI、DQ</td>
			   <td>16字、16字/256位、256位</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：MCD1000用户使用手册',
							downloadName:'manual|MCD1000用户使用手册.pdf'
						}
					]
				}
			} else if (TypeID == 51) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/CUS_NSerial.png'),
					],
					SerialName: '伺服器',
					SerialIntro: '',
					TypeInfo: [{
						TypeName: 'CUS系列',
						TypeIntro: '简介及主要技术参数：<br/>CUS_N是大工计控自主研发的小功率交流伺服驱动器，支持速度控制、位置控制、转矩控制、速度/位置控制、转矩/速度控制、位置/转矩控制等多种控制模式；支持SVPWM和正弦波驱动控制方式；伺服器最大差动脉冲输入频率500KHz，集电极脉冲输入频率300KHz，模拟量输入±10V，配合S型指令平滑产生器和PID+前馈复合控制器，可以改善电机加减速特征，在机械运转上也更加平稳，满足高速位移、精准定位等运动控制需求。支持环网通信，可通过专用协议实现于运动控制主控器进行映射<br/>CUS_N系列通用型伺服驱动器产品具有不同功率范围的6种型号：<br/>·分别为：   CUS002N100-2A、CUS004N100-2A、CUS007N100-2A、CUS010N100-2A、CUS015N100-2A、CUS020N100-2A。<br/>·额定输出功率：0.2KW           0.4KW          0.7KW          1.0KW          1.5KW          2.0KW'
					}],
					ParaTable: `<table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="3"><a>技术规格</a></td>
			   <td><a>CUS002N</a></td>
			   <td><a>CUS004N</a></td>
			   <td><a>CUS007N</a></td>
			   <td><a>CUS010N</a></td>
			   <td><a>CUS015N</a></td>
			   <td><a>CUS020N</a></td>
		   </tr>
		   <tr>
			   <td class="para-table-tag">物理特征</td>
				<td colspan="2" class="para-table-tag">外形尺寸(W×H×L)</td>
				<td colspan="6">163mm×75mm×164mm</td>
		   </tr>
		   <tr>
				<td rowspan="3" class="para-table-tag">产品规格</td>
			   <td colspan="2" class="para-table-tag">额定输出功率</td>
				<td>200W</a></td>
				<td>400W</a></td>
				<td>700W</a></td>
				<td>1000W</a></td>
				<td>1500W</a></td>
				<td>2000W</a></td>
		   </tr>
			<tr>
				 <td colspan="2" class="para-table-tag"><a>适配电机</a></td>
				<td>200W</a></td>
				<td>400W</a></td>
				<td>700W</a></td>
				<td>1000W</a></td>
				<td>1500W</a></td>
				<td>2000W</a></td>
			</tr>
			<tr>
				<td colspan="2" class="para-table-tag"><a>编码器线数</a></td>
				<td colspan="6">2500ppr/10000ppr</a></td>
			</tr>
			<tr>
				<td rowspan="2" class="para-table-tag"><a>电源特性</a></td>
				<td colspan="2" class="para-table-tag"><a>额定输入电压</a></td>
				<td colspan="6">170V~230VAC</a></td>
			</tr>
			<tr>
				<td colspan="2" class="para-table-tag"><a>额定电压频率</a></td>
				<td colspan="6">50Hz±5%</a></td>
			</tr>
			<tr>
				<td colspan="3" class="para-table-tag"><a>控制模式</a></td>
				<td colspan="6">速度控制、位置控制、转矩控制、速度/位置控制、转矩/速度控制、位置/转矩控制</a></td>
			</tr>
			<tr class="para-table-head">
				<td><a>插座</a></td>
				<td><a>名称</a></td>
				<td><a>数量</a></td>
				<td colspan="6"><a>参数说明</a></td>
			</tr>
			<tr>
				<td rowspan="4" class="para-table-tag"><a>编码器接口 CN2</a></td>
				<td class="para-table-tag"><a>差分输入信号</a></td>
				<td><a>6</a></td>
				<td colspan="6">A、 B、 Z、 U、 V、 W差分输入， 最高频率500KHz</a></td>
			</tr>
			<tr>
				<td class="para-table-tag"><a>电源输出</a></td>
				<td>1</a></td>
				<td colspan="6">给差分编码器供电的电源， +5V/150mA</a></td>
			</tr>
			<tr>
				<td class="para-table-tag">绝对值编码器</a></td>
				<td>1</a></td>
				<td colspan="6">1路RS-485接口， 连接绝对值编码器</a></td>
			</tr>
			<tr>
				<td class="para-table-tag">编码器供电</a></td>
				<td>1</a></td>
				<td colspan="6">3.6V电池正负极性输出， 给绝对值编码器供电</a></td>
			</tr>
			<tr>
				<td rowspan="4" class="para-table-tag"><a>主回路接口</a></td>
				<td class="para-table-tag">主回路电源输入</a></td>
				<td>1</a></td>
				<td colspan="6">3相220V交流电源输入</a></td>
			</tr>
			<tr>
				<td class="para-table-tag">控制回路电源输入</a></td>
				<td>1</a></td>
				<td colspan="6"> 单相220V控制回路电源输入</a></td>
			</tr>
			<tr>
				<td class="para-table-tag">伺服电机电源输出</a></td>
				<td>1</a></td>
				<td colspan="6">3相电机调速电压输出</a></td>
			</tr>
			<tr>
				<td class="para-table-tag">回生电路</a></td>
				<td>1</a></td>
				<td colspan="6">内部和外部回生电阻选择</a></td>
			</tr>
			<tr>
				<td class="para-table-tag"><a>网络</a></td>
				<td class="para-table-tag">以太网</a></td>
				<td>2</a></td>
				<td colspan="6">10/100Mbps自适应， RJ45接口， 支持高速环网HEBUS网络</a></td>
			</tr>
			<tr>
				<td rowspan="8" class="para-table-tag"><a>信号输入输出接口CN1</a></td>
				<td class="para-table-tag">开关量输入</a></td>
				<td>10</a></td>
				<td colspan="6">内部由+24V电源提供上拉， 外部输入部件的另一端接GND</a></td>
			</tr>
			<tr>
				<td class="para-table-tag">开关量输出</a></td>
				<td>6</a></td>
				<td colspan="6">NMOS输出， 驱动电流≤150mA</a></td>
			</tr>
			<tr>
				<td class="para-table-tag">模拟量输入</a></td>
				<td>3</a></td>
				<td colspan="6">通道0和1为0~10V单端对AGND输入， 通道2为-10V~10V差动输入</a></td>
			</tr>
			<tr>
				<td class="para-table-tag">模拟量输出</a></td>
				<td>2</a></td>
				<td colspan="6">单端对AGND输出， 范围： 0~3V</a></td>
			</tr>
			<tr>
				<td class="para-table-tag">编码器差分输出</a></td>
				<td>3</a></td>
				<td colspan="6">A、 B、 Z相差分输出</a></td>
			</tr>
			<tr>
				<td rowspan="2" class="para-table-tag">RS-485接口</a></td>
				<td rowspan="2">1</a></td>
				<td colspan="6">波特率： 1200/2400/4800/9600/19200/38400/57600/115200/500K/1Mbps</a></td>
			</tr>
			<tr>
				<td colspan="6">串口协议： Modbus协议和扩展IO协议</a></td>
			</tr>
			<tr>
				<td class="para-table-tag">直流24V电源输出</a></td>
				<td>1</a></td>
				<td colspan="6">由+24V和GND引脚输出， 为开关量输入和输出提供电源， 小于150mA</a></td>
			</tr>
			<tr>
				<td rowspan="3" class="para-table-tag">工作环境</a></td>
				<td colspan="2" class="para-table-tag">工作温度</a></td>
				<td colspan="6">-10℃~50℃</a></td>
			</tr>
			<tr>
				<td colspan="2" class="para-table-tag">工作湿度</a></td>
				<td colspan="6">20%~95%， 不结露</a></td>
			</tr>
			<tr>
				<td colspan="2" class="para-table-tag">抗干扰性</a></td>
				<td colspan="6">符合电磁兼容 3 级标准</a></td>
			</tr>
	</table>`,
					DownloadList: [
						{
							displayName:'文档：CUS_S系列伺服器使用手册',
							downloadName:'manual|CUS_S系列伺服器使用手册V1.1.pdf'
						},
						{
							displayName:'文档：CUS100系列伺服器使用手册',
							downloadName:'manual|CUS100系列伺服器使用手册.pdf'
						},
						{
							displayName:'文档：CUS300系列伺服器使用手册',
							downloadName:'manual|CUS300系列伺服器使用手册.pdf'
						}
					]
				}
			} else if (TypeID == 52) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/xxkw.jpg'),
					],
					SerialName: '伺服电机',
					SerialIntro: '',
					TypeInfo: [{
						TypeName: '爱智控制电机系列',
						TypeIntro: '爱智控制电机系列，根据电机的法兰尺寸，目前DCCE电机共分为6大类，近30种型号。<br/>具体的法兰尺寸有60,80,90,110,130,180，更详细的参数请参考下面的电机参数表和选型手册。'
					}],
					ParaTable: `<table class="para-table">
		   <tr class="para-table-head">
			   <td colspan="3"><a>伺服电机</a></td>
		   </tr>
		   <tr>
			   <td colspan="3"><a>注：电机型号不同参数报价不同，如需抱闸需另外增加费用。</a></td>
		   </tr>
		   <tr class="para-table-head">
			   <td><a>法兰尺寸</a></td>
			   <td><a>电机型号</a></td>
			   <td><a>转矩&功率&转速</a></td>
		   </tr>
		   <tr>
			   <td rowspan="3">60</td>
			   <td>60ST-M00630LB</td>
			   <td>0.63NM，0.4KW，3000转</td>
		   </tr>
		   <tr>
			   <td>60ST-M01330LB</td>
			   <td>1.27NM，0.4KW，3000转</td>
		   </tr>
		   <tr>
			   <td>60ST-M01930LB</td>
			   <td>1.9NM，0.6KW，3000转</td>
		   </tr>
		   <tr>
			   <td rowspan="4">80</td>
			   <td>80ST-M01330LB</td>
			   <td>1.3NM，0.4KW，3000转</td>
		   </tr>
		   <tr>
			   <td>80ST-M02430LB</td>
			   <td>2.4NM，0.75KW，3000转</td>
		   </tr>
		   <tr>
			   <td>80ST-M03520LB</td>
			   <td>3.5NM，0.73KW，2000转</td>
		   </tr>
		   <tr>
			   <td>80ST-M04025LB</td>
			   <td>4.0NM，1.0KW，2500转</td>
		   </tr>
		   <tr>
			   <td rowspan="3">90</td>
			   <td>90ST-M02430LB</td>
			   <td>2.4NM,0.75KW,3000转</td>
		   </tr>
		   <tr>
			   <td>90ST-M03520LB</td>
			   <td>3.5NM,0.75KW,2000转</td>
		   </tr>
		   <tr>
			   <td>90ST-M04025LB</td>
			   <td>4.0NM,1.0KW,2500转</td>
		   </tr>
		   <tr>
			   <td rowspan="5">110</td>
			   <td>110ST-M02030LB</td>
			   <td>2NM，0.6KW，3000转</td>
		   </tr>
		   <tr>
			   <td>110ST-M04030LB</td>
			   <td>4NM，1.2KW，3000转</td>
		   </tr>
		   <tr>
			   <td>110ST-M05030LB</td>
			   <td>5NM，1.5KW，3000转</td>
		   </tr>
		   <tr>
			   <td>110ST-M06020LB</td>
			   <td>6NM，1.2KW，2000转</td>
		   </tr>
		   <tr>
			   <td>110ST-M06030LB</td>
			   <td>6NM，1.6KW，3000转</td>
		   </tr>
		   <tr>
			   <td rowspan="8">130</td>
			   <td>130ST-M04025LB</td>
			   <td>4NM，1.0KW，2500转</td>
		   </tr>
		   <tr>
			   <td>130ST-M05025LB</td>
			   <td>5NM，1.3KW，2500转</td>
		   </tr>
		   <tr>
			   <td>130ST-M06025LB</td>
			   <td>6NM，1.5KW，2500转</td>
		   </tr>
		   <tr>
			   <td>130ST-M07725LB</td>
			   <td>7.7NM，2.0KW，2500转</td>
		   </tr>
		   <tr>
			   <td>130ST-M10015LB</td>
			   <td>10NM，1.5KW，1500转</td>
		   </tr>
		   <tr>
			   <td>130ST-M10025LB</td>
			   <td>10NM，2.6KW，2500转</td>
		   </tr>
		   <tr>
			   <td>130ST-M15015LB</td>
			   <td>15NM，2.3KW，1500转</td>
		   </tr>
		   <tr>
			   <td>130ST-M15025LB</td>
			   <td>15NM，3.8KW，2500转</td>
		   </tr>
		   <tr>
			   <td rowspan="6">180</td>
			   <td>180ST-M17215</td>
			   <td>17.2NM，2.7KW，1500转</td>
		   </tr>
		   <tr>
			   <td>180ST-M19015</td>
			   <td>19NM，3.0KW，1500转</td>
		   </tr>
		   <tr>
			   <td>180ST-M21520</td>
			   <td>21.5NM，4.5KW，2000转</td>
		   </tr>
		   <tr>
			   <td>180ST-M27015</td>
			   <td>27NM，4.3KW，1500转</td>
		   </tr>
		   <tr>
			   <td>180ST-M35015</td>
			   <td>35NM，5.5KW，1500转</td>
		   </tr>
		   <tr>
			   <td>180ST-M48015</td>
			   <td>48NM，7.5KW，1500转</td>
		   </tr>
		   </table>`,
					DownloadList: [
						{
							displayName:'文档：大工计控伺服电机样本',
							downloadName:'manual|大工计控伺服电机手册2016-4-21.pdf'
						}
					]
				}
			} else if (TypeID == 53) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/plcconfig_tongxunpeizhi.png'),
						require('@/assets/images/edge/products/details/plcconfig_xiazaijingxiang.png'),
						require('@/assets/images/edge/products/details/plcconfig_qushitu.png'),
						require('@/assets/images/edge/products/details/plcconfig_shebeicanshu.png')
					],
					SerialName: 'PLC_Config',
					SerialIntro: 'PLC_Config 是用于对PEC、AIO、DIO、PMC、MEC、EDC、iTC等系列可编程控制器进行逻辑编程的组态软件。包括设备管理、通信配置、程序管理、状态符号表、趋势图等多项便于编程的功能模块，支持兼容IEC61131-3 标准的功能块、梯形图、指令码编程语言，支持符合PLC_Open 标准的运动控制指令以及DIN66025 标准的G 代码指令。<br/>PLC_Config 是标准的Windows应用程序，利用其提供的各功能模块，可以有效的提升编程效率，无论是逻辑编程、设备管理，还是监控、调试和维护，PLC_Config 软件都将为您节省大量的时间和金钱。',
					TypeInfo: [{
							TypeName: '通信配置与设备管理',
							TypeIntro: '用于对同一网段内多个设备的在线状态、设备参数、运行状态等进行配置<br/> » 扫描网段内在线设备与从设备<br/> » 扫描ZigBee 设备拓扑网络<br/> » 在线设置设备各项参数<br/> » 设置从设备参数<br/> » 查看设备状态'
						},
						{
							TypeName: '程序管理',
							TypeIntro: '提供多种编程语言之间的转换，支持多项辅助功能，方便用户更快更好地编写设备运行逻辑<br/> » 梯形图编程、功能块编程<br/> » G 代码编程、运动控制编程<br/> » STL 指令码显示<br/> » 程序导入导出，支持西门子STEP7 工程导入<br/> » 梯形图与功能块互转<br/> » 程序调试与进程监控'
						},
						{
							TypeName: '交叉引用',
							TypeIntro: '列出组态程序中变量的使用状态，使用户能及早的发现变量交叉使用的情况，并合理的分配变量空间<br/> » 字引用统计、位引用统计<br/> » 引用定位<br/> » 对引用情况实现双击定位<br/> » 对变量交叉使用提示警告'
						},
						{
							TypeName: '状态符号表',
							TypeIntro: '用于对程序所用变量统一管理与监控<br/> » 为变量定义符号名称和说明<br/> » 查看变量Modbus 地址，也可通过Modbus 地址添加变量<br/> » 支持导入导出标准格式文档，实现与其它程序交互<br/> » 支持在线监控，读写变量值<br/> » 可将西门子STEP7-200 符号表导入PLC_Config 中'
						},
						{
							TypeName: '趋势图',
							TypeIntro: '用于监控多个变量在某段时间内的变化曲线<br/> » 每幅趋势图可同时监控8 个自定义颜色的变化曲线<br/> » 可打印曲线记录图形'
						},
						{
							TypeName: '统一下载',
							TypeIntro: 'DownloadUtility统一下载软件为用户提供了整套控制系统方案的一键下载功能。调试时用户可对控制系统中的设备参数与组态程序生成下载镜像，批量生产时通过统一下载软件对整套系统或其中的部分设备进行参数与程序配置，提高生产效率<br/> » 批量下载设备参数信息、组态程序、从设备参数、从设备组态程序<br/> » 支持在线和离线采集、配置，统一下载信息<br/> » 可筛选下载内容'
						},
						{
							TypeName: '指令集',
							TypeIntro: '具有完备的指令集，可以简单快速的编写复杂程序<br/> » 位逻辑，包括常开、常闭、与或非、上升沿、下降沿、复位、置位等<br/> » 网络通讯，支持EPA、Modbus、TCP、UDP、串口自由通信协议等<br/> » 运算指令，包括整形运算、浮点运算、比较、按位操作、移位等<br/> » PID 指令，包括I_PID、P_PID，支持自整定<br/> » 定时器/ 计数器，定是周期为1ms<br/> » 程序控制，包括指令跳转、FOR 循环、子程序调用、中断程序调用等<br/> » 运动控制，包括单轴指令、多轴指令、轴组指令等<br/> » G 代码，M 代码<br/> » 定制指令，为工件检测、生产线经济运行、存储用户数据、数据校验、pH 测量等提供封装指令'
						}
					],
					ParaTable: `<table class="para-table">
	<tr class="para-table-head">
		<td colspan="3"><a>PLC_Config更新日志</a></td>
	</tr>
	<tr>
		<td colspan="2" class="para-table-tag">v2.11.8 Alpha</td>
		<td>1.新增设备PAG100、PAG200、VITxxxS、VITxxxN、VITxxxE、CIO211、CIO210</td>
	</tr>
	<tr>
		<td colspan="2" class="para-table-tag">2.11.0</td>
		<td>1.新增设备CIO300、CIO310、EA2xx系列、MAC1132、MAC1630<br/>2.新增加密权限管理功能<br/>3.新增G代码IF和WHILE语句</td>
	</tr>
	<tr>
		<td colspan="2" class="para-table-tag">2.10.16</td>
		<td>1.新增MAC1133、MAC1603、MAC1613、MAC1630产品类型<br/>2.新增MC_PWM指令<br/>3.新增0~10V，-10~+10~AI类型</td>
	</tr>
	<tr>
		<td colspan="2" class="para-table-tag">2.10.15 Alpha</td>
		<td>1.新增CIO200高速输出功能</td>
	</tr>
	<tr>
		<td colspan="2" class="para-table-tag">2.10.14 Alpha</td>
		<td>1.新增2M、3M、4Mbps波特率配置<br/>2.新增MAC1110、MAC1120、MAC1130、NCC2040设备类型<br/>3.新增CRC_G、CRC_C、BCC_G、BCC_C、LRC_G、LRC_C指令<br/>4.移除对DEC系列产品、PEC中A系列产品、PEC6100、PEC6200等产品的支持</td>
	</tr>
	<tr>
		<td colspan="2" class="para-table-tag">2.10.12</td>
		<td>1.全面支持最新的MAC系列控制器产品<br/>2.新增设备类型CIO110、PEC6900、PEC6680<br/>3.新增指令MOV_B、B_W、W_B、SC_AFC、TCP_AFC、UDP_AFC<br/>4.新增指令MC_EmgStopSet、MC_MultiAxesSyncMove</td>
	</tr>
	<tr>
		<td colspan="2" class="para-table-tag">2.9.11 Alpha</td>
		<td>1.新增设备类型MAC300、MAC1000、PEC3A70、PEC6050、PEC6250、PEC6300、PEC6600、PEC6800、PEC6A00、PEC6A50、PEC8A00、PEC8A60、CIO2000、DEC3A10、DEC3A00、DEC5A60 、DEC5AAQ、DEC5ADQ、<br/>2.新增状态符号表导入功能、PAC主站配置界面、IO配置界面<br/>3.新增指令CodeMap、IOMonitor、B_W、W_B、MEAN_W、PLUS、气缸<br/>4.G代码增加T指令，修改M指令<br/>5.运动控制增加SCARA机器人模型</td>
	</tr>
	<tr>
		<td colspan="2" class="para-table-tag">2.8.8 Alpha</td>
		<td>1.将以太网和串口版PLC_Config进行合并<br/>2.增加跨网段设备通讯功能<br/>3.增加PEC3A00，PEC8A00，PEC5A00</td>
	</tr>
	<tr>
		<td colspan="2" class="para-table-tag">2.4.7 Beta</td>
		<td>1.新增部分以太网控制功能块和MC_CircleMov运动控制块，以此实现远程设备通信功能<br/>2.增加梯形图指令优化功能，提高梯形图指令的运行效率<br/>3.支持PEC6000、6100、6200，EDC8000新设备</td>
	</tr>
	<tr>
		<td colspan="2" class="para-table-tag">2.2.2</td>
		<td>首版发布</td>
	</tr>
	
      <tr class="para-table-head">
		<td colspan="3"><a>PLC_Config技术数据</a></td>
	  </tr>
	  <tr>
		<td colspan="2" class="para-table-tag">
		  <strong>软件大小</strong>
		</td>
		<td>21.7M</td>
	  </tr>
	  <tr>
		<td colspan="2" class="para-table-tag">
		  <strong>软件语言</strong>
		</td>
		<td>简体中文</td>
	  </tr>
	  <tr>
		<td colspan="2" rowspan="5" class="para-table-tag">
		  <strong>操作系统要求</strong>
		</td>
		<td>Microsoft Windows XP Professional
		<br /></td>
	  </tr>
	  <tr>
		<td>Microsoft Windows Vista</td>
	  </tr>
	  <tr>
		<td>Microsoft Windows 7</td>
	  </tr>
	  <tr>
		<td>Microsoft® Windows® Server 2003</td>
	  </tr>
	  <tr>
		<td>Microsoft® Windows® Server 2008</td>
	  </tr>
	  <tr>
		<td colspan="2" rowspan="3" class="para-table-tag">
		  <strong>最低配置</strong>
		</td>
		<td>CPU：1GHz 内存：256MB 硬盘：512M 可用硬盘空间</td>
	  </tr>
	  <tr>
		<td>Super VGA(1024 × 768) 分辨率的视频适配器和显示器</td>
	  </tr>
	  <tr>
		<td>键盘和鼠标或兼容的定位设备</td>
	  </tr>
	  <tr>
		<td colspan="2" class="para-table-tag">
		  <strong>支持设备</strong>
		</td>
		<td>MAC系列、PEC 系列、AIO/DIO/PMC 系列、EDC 系列、MEC
		系列、iAC/iTC/iTD 系列</td>
	  </tr>
	  <tr>
		<td colspan="2" class="para-table-tag">
		  <strong>设备可配参数</strong>
		</td>
		<td>设备地址、串口通讯配置、实时时钟
		<br/>AIAO 通道类型、通道使能、工程校准值
		<br/>V 区保持、从设备类型、从设备通道映射
		<br/>冗余参数、ZigBee 参数、转发参数</td>
	  </tr>
	  <tr>
		<td colspan="2" class="para-table-tag">
		  <strong>编程语言</strong>
		</td>
		<td>梯形图、功能块、STL、G 代码</td>
	  </tr>
	  <tr>
		<td rowspan="17" class="para-table-tag">
		  <strong>指令集</strong>
		</td>
		<td bgcolor="#CCCCCC">位逻辑</td>
		<td>常开、常闭、与或非、沿触发、置位、复位</td>
	  </tr>
	  <tr>
		<td bgcolor="#CCCCCC">整型运算</td>
		<td>整型运算、按位运算、循环移位、转换</td>
	  </tr>
	  <tr>
		<td bgcolor="#CCCCCC">浮点运算</td>
		<td>三角函数、反三角函数、幂指数运算、PID 运算，支持PID
		参数自整定</td>
	  </tr>
	  <tr>
		<td bgcolor="#CCCCCC">比较</td>
		<td>整型比较、浮点比较、有符号无符号比较</td>
	  </tr>
	  <tr>
		<td bgcolor="#CCCCCC">程序控制</td>
		<td>跳转、循环、子程序调用、G 代码执行</td>
	  </tr>
	  <tr>
		<td bgcolor="#CCCCCC">中断</td>
		<td>中断使能、中断类型设置</td>
	  </tr>
	  <tr>
		<td bgcolor="#CCCCCC">定时器/ 计数器</td>
		<td>定时触发、计数触发，定时精度包括1ms、10ms 和100ms
		三种</td>
	  </tr>
	  <tr>
		<td bgcolor="#CCCCCC">网络通讯</td>
		<td>支持EPA、Modbus、TCP、UDP、串口自由通信协议等</td>
	  </tr>
	  <tr>
		<td bgcolor="#CCCCCC">运动控制</td>
		<td>单轴、多轴、轴组指令</td>
	  </tr>
	  <tr>
		<td bgcolor="#CCCCCC">G 代码</td>
		<td>
		G00：快速定位G01：直线插补G02：顺时针圆弧插补G03：逆时针圆弧插补G04：暂停，精确停止
		<br />G17：X-Y 平面G18：Z-X 平面G19：Y-Z 平面G53：设定工件坐标系注销
		<br />G54~G59：选用1~6 号工件坐标系G70：英制尺寸G71：公制尺寸G90：绝对值方式编程
		<br />G91：增量方式编程
		<br />M00：程序暂停M02：程序结束并复位M03：主轴正转M04：主轴反转M05：主轴停止M06：刀具交换
		<br />M07：雾冷却开M08：液冷却开M09：冷却关M30：程序结束并返回程序头M98：调用子程序
		<br />M99：子程序结束返回/ 重复执行</td>
	  </tr>
	  <tr>
		<td bgcolor="#CCCCCC">定制指令</td>
		<td>
		可为特殊需求定制专业指令，例如工件检测、经济模式、数据校验、存储、排序、PH
		测量值</td>
	  </tr>
    </table>`,
					DownloadList: [
						{
							displayName:'安装包：PLC_Config 2.11.8 Alpha',
							downloadName:'cfgPr|PLC_Config 2.11.8 Alpha.exe'
						},
						{
							displayName:'文档：PLC_Config说明文档',
							downloadName:'manual|PLC_Config说明文档.chm'
						}
					]
				}
			} else if (TypeID == 54) {
				data = {
					imgsPath: [
						require('@/assets/images/edge/products/details/dview_tuopubianji.jpg'),
						require('@/assets/images/edge/products/details/dview_bianliangqu.jpg'),
						require('@/assets/images/edge/products/details/dview_renjijiemian.jpg'),
						require('@/assets/images/edge/products/details/dview_shujuku.jpg')
					],
					SerialName: 'Dview HMI',
					SerialIntro: 'DView是具有设备管理、实时数据管理、视频管理、数据库管理和地理信息管理等功能的监控管理系统开发平台。集成了人机界面组态、视频组态和数据库开发组态等多种功能。通过所见即所得的组态方式完成画面开发与数据关联。实现实时数据显示，动画显示，视频监控，生产过程、人工与原材料管理，数据存储、统计分析等功能。为用户提供高效快捷的人机界面和制造执行管理系统的开发与维护工具。',
					TypeInfo: [{
							TypeName: '设备拓扑编辑',
							TypeIntro: '用户可通过扫描或离线配置的方式生成设备拓扑图，形象的管理现场设备<br/> √ 扫描在线设备，获得连接关系<br/> √ 维护设备运行状态<br/> √ 编辑离线设备，配置连接关系<br/> √ 打印设备拓扑图<br/> √ 配置，导入或导出、设备参数'
						},
						{
							TypeName: '变量定义',
							TypeIntro: 'DVew支持两种类型的变量:<br/> √ IO变量:与设备寄存器对应，通过设备通信刷新实时值<br/> √ 内存变量:与设备无关，通过执行赋值脚本计算实时值<br/> √ OPC变量:DOPCServor通过Client组件与DXP进行数据交互，OPC客户端根据OPC标准与DOPCServer交互从而使OPC客户端软件可以与DXP进行数据交互<<br/> √ 程序运行时，自动加载工程文件并获取该工程信息<br/> √ DOPCServer提供变量监控功能<br/> √ 提供日志系统，方便查看工程加载与关闭信息<br/> √ 可通过关闭OPCServer来关闭工程<br/>DView通过变量表管理变量，在变量表中可以:<br/> √ 定义设备基本信息，如名称、类型、权限等<br/> √ 定义变量数据源信息，如设备、地址、刷新时间等<br/> √ 定义变量报警信息，如上下限、变化率、目标值报警等<br/> √ 根据逻辑划分变量组，便于管理<br/> √ 复制、粘贴、批量定义、导入导出变量表<br/> √ 打印变量表<br/>DView中关于Client接口函数说明<br/>Client控件是上层程序(HMI，PLC_Config,用户程序等需要从服务器读取数据的程序)向主(次)服务器请求数据的一个控件。<br/>(1)可将数据初始化<br/>(2)读、写单个工程变量<br/>(3)读、写多个工程变量<br/>(4)可作为内部调用函数的接口'
						},
						{
							TypeName: '人机界面开发',
							TypeIntro: '提供简单友好的开发界面和丰富的专业图库，可将变量值与界面元素的位置、尺寸、颜色、动画等属性关联，逼真的再现生产过程。配合SQLServer等关联数据库,可以通过按键、文字、表格等控件实现数据的增加、删除、修改和查询操作，实现企业生产过程与信息管理。配合变量与设备报警功能，实现现场装备与生产过程的故障诊断与提示。配合视频控件与视频服务器可实现现场实时图像的监控与发布。<br/> √ 提供丰富的工业矢量图库<br/> √ 支持精灵控件、爱智控制工控组件、Windows控件和第三方ActiveX控件<br/> √ 支持变量输入输出、鼠标动作、目标移动、尺寸、填充、颜色等多种事件引起的画面动作<br/> √ 支持基于安全区的用户权限配置<br/> √ 支持趋势图、报表、语音、Office等通用组件<br/> √ 提供丰富的变量类型与设备报警界面控件，可显示报警信息并播放提示录音<br/> √ 支持VBScript脚本，可以通过脚本操作页面与控件属性'
						},
						{
							TypeName: '人机界面的跨平台发布',
							TypeIntro: '支持本地、网络和跨平台三种发布方式，方便信息监控与数据共享。提供向导式安装包制作工具，采取版权保护措施,发布的工程须授权使用。<br/> √ 本地发布组态工程生成的可执行文件供用户使用<br/> √ 网络发布生成WebServer并在服务器端运行;用户可通过浏览器直接访问人机界面，无需安装其他客户端程序<br/> √ 本地和网络发布都以安装包的形式提供给客户，安装后即可使用，无需额外配置<br/> √ 跨平台发布是使用IIS进行标准的HTML发布，发布后移动终端可通过无线网络对该发布地址进行访问及其他操作'
						},
						{
							TypeName: '视频监控开发',
							TypeIntro: '支持视频服务，可方便的与USB、同轴电缆以及网络摄像头连接，实现视频监视、存储与网络发布。<br/> √ 支持目前主流厂商的视频设备驱动<br/> √ 支持多路视频集成发布与录制<br/> √ 可分别设定视频发布与录制的分辨率与帧速率'
						},
						{
							TypeName: '数据库开发',
							TypeIntro: '可通过图形化界面和向导实现数据表结构定义和表关系配置，在人机界面开发环境中支持画面元素与数据库数据的动态关联。可方便实现生产过程管理、办公自动化以及制造执行系统的数据库开发。<br/> √ 可通过内嵌的数据库编辑器定义数据表格式<br/> √ 将可见界面元素与数据库内容关联，自动生成SQL语句<br/> √ 配合按键、表格等控件实现对数据库内容的增加、删除、修改、查询等操作'
						},
						{
							TypeName: 'GIS功能',
							TypeIntro: 'DView软件支持地理信息功能，通过加载地图文件，可以方便的浏览指定区域的地理信息;通过添加自定义兴趣点，可在地理信息中实现实时数据的显示，页面跳转等操作。<br/> √ 支持.gst格式文件<br/> √ 浏览指定区域的地理信息<br/> √ 添加自定义兴趣点<br/> √ 实现实时数据的显示<br/> √ 支持对当前地图进行放大、缩小、移动<br/> √ 配置地理信息跳转页面'
						},						
					],
					ParaTable: `<table class="para-table">
	<tr class="para-table-head">
		<td colspan="3"><a>DView更新日志</a></td>
	</tr>
	<tr>
		<td colspan="2" class="para-table-tag">Dview v2.6.2</td>
		<td>1.新增通用性设备的支持，新增与西门子300和400通信，新增远程DTU通信方式，完善脚本编译和图元编辑功能。<br/>2. 基于HTML5技术，实现了跨平台发布方式，可使用手机进行远程监控。<br/>3. 使用2.6版本以上的DView需要更换加密狗。</td>
	</tr>
	<tr>
		<td colspan="2" class="para-table-tag">Dview v2.5.2</td>
		<td>1.新增PAC系列</td>
	</tr>
	<tr>
		<td colspan="2" class="para-table-tag">Dview v2.4.2</td>
		<td>性能优化与BUG消除</td>
	</tr>
	<tr>
		<td colspan="2" class="para-table-tag">Dview v2.3.0</td>
		<td>1.新增DView双机冗余功能<br/>2.支持运行状态下手动切换DXP冗余状态<br/>3.新增GIS控件用于支持地理信息系统<br/>4.新增封送逻辑至服务器端执行功能<br/>5.支持模块发起TCP连接的监控机制<br/>6.支持通过DTU设备的监控机制<br/>7.支持基于数据库的用户管理<br/>8.支持多种数据库的操作<br/>9.重新包装Windows控件以及精灵控件<br/>10.支持第三方控件<br/>11.新增报警控件<br/>12.重新设计属性框显示的内容<br/>13.网络运行环境支持虚拟路径<br/>14.增加对数据库组态的支持<br/>15.提高WebServer对数据库操作转发执行效率<br/>16.优化工程编译速度<br/>17.修改若干缺陷<br/>18.更新了设备描述文件<br/>19.优化报文收发机制<br/>20.增加了对PPI协议设备的支持</td>
	</tr>
	<tr>
		<td colspan="2" class="para-table-tag">Dview v2.0.0</td>
		<td>发布首版基于Windows操作系统、面向工业自动化领域的数据监控系统软件开发平台，包含Dview设备监控管理平台、DXP数据交互平台软件和DHMI人机界面组态软件，集成设备管理、变量管理、通信调度、人机界面开发、Web服务、历史数据存储等多种功能<br/>支持公司PEC系列 AIO系列 DIO系列 PMC系列 EDC系列 MEC系列 iTD系列 iTC系列产品</td>
	</tr>
	<tr>
		<td colspan="2" class="para-table-tag">DCCE HMIware v2.5</td>
		<td>DCCE HMIware组态编辑软件,是专为DCCE触摸屏开发的专用人机界面组态软件,该软件为用户提供了一个强大的集成开发环境,产品广泛应用于医疗、化工、电力、印刷、纺织、智能家居等领域</td>
	</tr>
      <tr class="para-table-head">
        <td colspan="3"><a>DView技术数据</a></td>
      </tr>
      <tr>
        <td colspan="2" class="para-table-tag">
          <strong>软件大小</strong>
        </td>
        <td>216M</td>
      </tr>
      <tr>
        <td colspan="2" class="para-table-tag">
          <strong>软件语言</strong>
        </td>
        <td>简体中文</td>
      </tr>
      <tr>
        <td colspan="2" rowspan="6" class="para-table-tag">
          <strong>操作系统要求</strong>
        </td>
        <td>Microsoft® Windows XP Professional</td>
      </tr>
      <tr>
        <td>Microsoft® Windows Vista</td>
      </tr>
      <tr>
        <td>Microsoft® Windows Server 2003</td>
      </tr>
      <tr>
        <td>Microsoft® Windows 7</td>
      </tr>
      <tr>
        <td>Microsoft® Windows 8</td>
      </tr>
      <tr>
        <td>Microsoft® Windows Server 2008</td>
      </tr>
      <tr>
        <td colspan="2" rowspan="3" class="para-table-tag">
          <strong>最低配置</strong>
        </td>
        <td>CPU：1.2 GHz 及以上
        <br />内存最低512 MB，建议配备1 GB
        <br />最少4 GB 可用硬盘空间</td>
      </tr>
      <tr>
        <td>Super VGA (1024 × 768) 或更高分辨率的视频适配器和显示器</td>
      </tr>
      <tr>
        <td>键盘和鼠标或兼容的定位设备</td>
      </tr>
      <tr>
        <td rowspan="17" width="100px" class="para-table-tag">
          <strong>指令集</strong>
        </td>
        <td width="100" align="left" bgcolor="#CCCCCC" class="text2">设备拓扑编辑</td>
        <td>监视、扫描、离线编辑、导入导出、打印</td>
      </tr>
      <tr>
        <td width="100" align="left" bgcolor="#CCCCCC" class="text2">变量定义</td>
        <td>I/O
        变量、内存变量、历史数据存储、报警（下下限、下限、上限、上上限、变化率、目标值、位变量报警）、分组、导入导出、打印</td>
      </tr>
      <tr>
        <td width="100" align="left" bgcolor="#CCCCCC" class="text2">界面开发</td>
        <td>界面元素（工业矢量图库、精灵控件、DCCE 工控组件、Windows
        控件、ActiveX 控件）
        <br />动画连接( 输入输出、鼠标事件、移动、填充、尺寸变化等）
        <br />、支持VBScript 脚本</td>
      </tr>
      <tr>
        <td width="100" align="left" bgcolor="#CCCCCC" class="text2">发布方式</td>
        <td>本地发布与安装包制作
        <br />基于B/S 架构的网络发布与安装包制作</td>
      </tr>
      <tr>
        <td width="100" align="left" bgcolor="#CCCCCC" class="text2">视频监控</td>
        <td>支持USB、同轴电缆、网络摄像头
        <br />支持多路视频集成监视、存储、网络发布
        <br />视频存储与发布分辨率支持（160*120 至720*480，13 级可调）
        <br />视频存储与发布帧速率支持（0.5fps、1fps、5fps、10fps、15fps、29.97fps）</td>
      </tr>
      <tr>
        <td width="100" align="left" bgcolor="#CCCCCC" class="text2">数据库开发</td>
        <td>支持通过ADO.NET 与数据库连接
        <br />支持数据库编辑器定义数据表格式
        <br />配合按键、表格等控件实现数据库的增加、修改、删除、查询操作，自动生成SQL 语句</td>
      </tr>
      <tr>
        <td width="100" align="left" bgcolor="#CCCCCC" class="text2">数据接口</td>
        <td>提供OPC 服务器、OPC 客户端
        <br />提供符合OLE2.0 规范的DCCEClient ActiveX 组件</td>
      </tr>
    </table>`,
					DownloadList: [
						{
							displayName:'安装包：DView_v2.6.7.10241',
							downloadName:'cfgPr|DView_v2.6.7.10241.exe'
						},
						{
							displayName:'安装包：DCCE HMIware',
							downloadName:'cfgPr|DCCE HMIware v2.5.zip'
						},
						{
							displayName:'文档：DView安装指南',
							downloadName:'manual|DView安装指南.chm'
						},
						{
							displayName:'文档：DView快速入门',
							downloadName:'manual|DView快速入门.chm'
						},
						{
							displayName:'文档：DView使用说明',
							downloadName:'manual|DView使用说明.chm'
						}
					]
				}
			}

			this.SerialAllInfo = data;
		}
	}
}

